<template>
  <div class="mainContainer" @contextmenu.prevent="null" style="user-select: none; cursor: default;">
    <v-card v-if="navigation.searchVisible" :border="$vuetify.display.sm || $vuetify.display.xs ? null : 'e'" elevation="0" rounded="0" color="border" class="navigationContainer"> 
      <v-card elevation="0" rounded="0" color="primary" style="width: 100%; padding: 15px; display: flex; align-items: center;">
        <v-icon size="large" color="indigo">mdi-package</v-icon>
        <v-icon color="indigo" style="margin-right: 10px;">mdi-trending-{{ input.sort == 'DESC' ? 'up' : 'down' }}</v-icon>
        <h4>TENDENCIA DE VENTA</h4>
        <div style="margin-left: auto; display: flex; gap: 5px;">
          <v-icon @click="selectCRMProductSaleFromCRMProductSaleView()" :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView" size="x-small" class="hoverableElement">mdi-magnify</v-icon>
          <v-icon @click="setDefaultValues()" :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView" size="x-small" class="hoverableElement">mdi-backspace</v-icon>
          <v-icon @click="$generalFunctions.default.copyToClipboard(this, 'Búsqueda de tendencia de venta', 'a', null)" :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView" size="x-small" class="hoverableElement">mdi-share-variant</v-icon>
          <template v-if="navigation.searchVisible == true && display.CRMProductSale.length > 0">
            <v-icon @click="navigation.searchVisible = false" :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView" size="x-small" class="hoverableElement hideSearchContainer">mdi-arrow-left-bottom-bold</v-icon>
          </template>
        </div>
      </v-card> 
      <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
      <div class="navigationSearchContainer">
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros de la orden:</strong></span>
          <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
        </div>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-date-input
              v-bind="props"
              ref="CRMWhatsappInvoiceCreationDatetime"
              v-model="input.CRMWhatsappInvoiceCreationDatetime"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="updateURLSearchQuery()"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :max="new Date().toISOString().split('T')[0]"
              prepend-inner-icon="mdi-calendar"
              prepend-icon=""
              label="Filtrar por fecha de creación"
              variant="outlined"
              density="compact"
              multiple="range"
              autocomplete="off"
              hide-details
              clearable
              style="margin-bottom: 15px;"
            ></v-date-input>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por fecha de creación de la orden permite buscar la tendencia de venta segun las ordenes generadas en una fecha específica. Al presionar el ícono de la izquierda se limpia el filtro de fecha de creación de la tendencia de venta colocada</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMLocalityID"
              v-model="input.CRMLocalityID"
              v-model:search="input.CRMLocalityIDSearch"
              :items="systemInformationData.CRMLocalities"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allCRMLocalityIDSelected = input.CRMLocalityID.length == systemInformationData.CRMLocalities.length; input.CRMLocalityMapDivisionID.length = 0; input.allCRMLocalityMapDivisionIDSelected = false; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              item-title="CRMLocalityName"
              item-value="CRMLocalityID"
              prepend-inner-icon="mdi-store"
              label="Filtrar por localidad"
              placeholder="Todas las localidades"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMLocalityIDSelected" 
                  @update:model-value="input.CRMLocalityID = input.allCRMLocalityIDSelected ? systemInformationData.CRMLocalities.map(CRMLocality => CRMLocality.CRMLocalityID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMLocalityID.includes(item.value)"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMLocalityID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <v-chip :color="item.raw.CRMLocalityColor" variant="flat" elevation="2" label style="margin-top: 5px; margin-bottom: 5px;">
                      <p>{{ item.raw.CRMLocalityName }}</p>
                    </v-chip>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityColor : 'primary'" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMLocalityID = input.CRMLocalityID.filter(CRMLocalityID => CRMLocalityID != item.value); input.allCRMLocalityIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMLocalityID.length - 3 }} localidad{{ input.CRMLocalityID.length - 3 == 1 ? '' : 'es' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La localidad a la que pertenece la orden. Si se coloca al menos una localidad, se buscarán todas las ordenes que pertenezcan a la localidad o localidades seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las localidades disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMLocalityMapDivisionID"
              v-model="input.CRMLocalityMapDivisionID"
              v-model:search="input.CRMLocalityMapDivisionIDSearch"
              :items="computed_CRMLocalityMapDivision"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allCRMLocalityMapDivisionIDSelected = input.CRMLocalityMapDivisionID.length == display.CRMLocalityMapDivision.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-map-marker"
              item-title="CRMLocalityMapDivisionName"
              item-value="CRMLocalityMapDivisionID"
              label="Filtrar por zona geográfica"
              placeholder="Todas las zonas geográficas"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMLocalityMapDivisionIDSelected" 
                  @update:model-value="input.CRMLocalityMapDivisionID = input.allCRMLocalityMapDivisionIDSelected ? display.CRMLocalityMapDivision.map(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMLocalityMapDivisionID.includes(item.value)"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMLocalityMapDivisionID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID).CRMLocalityColor : 'primary'" variant="flat" elevation="2" label style="margin-top: 5px; margin-bottom: 5px;">
                      <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID).CRMLocalityName : 'No registrada' }}</p>
                      <div style="display: flex; align-items: center;">
                        <v-icon size="small" style="margin: 0px 5px;">mdi-arrow-right-bold</v-icon>
                        <p style="font-size: x-small;">{{ item.raw.CRMLocalityMapDivisionName }}</p>
                      </div>
                    </v-chip>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip 
                  v-if="index < 3" 
                  :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID).CRMLocalityColor : 'primary'" 
                  variant="flat" 
                  elevation="2"
                  label
                >
                  <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.raw.CRMLocalityID).CRMLocalityName : 'No registrada' }}</p>
                  <div style="display: flex; align-items: center;">
                    <v-icon size="small" style="margin: 0px 5px;">mdi-arrow-right-bold</v-icon>
                    <p style="font-size: x-small;">{{ item.raw.CRMLocalityMapDivisionName }}</p>
                  </div>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMLocalityMapDivisionID = input.CRMLocalityMapDivisionID.filter(CRMLocalityMapDivisionID => CRMLocalityMapDivisionID != item.value); input.allCRMLocalityMapDivisionIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMLocalityMapDivisionID.length - 3 }} {{ input.CRMLocalityMapDivisionID.length - 3 == 1 ? 'división' : 'divisiones' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La zona geográfica de entrega de la orden. Si se coloca al menos una zona geográfica, se buscarán todas las ordenes entregadas en la zona o zonas geográficas seleccionadas. Al presionar el ícono de la derecha se seleccionan todas zonas geográficas disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappInvoiceCreationCRMAgentID"
              v-model="input.CRMWhatsappInvoiceCreationCRMAgentID"
              v-model:search="input.CRMWhatsappInvoiceCreationCRMAgentIDSearch"
              :items="systemInformationData.CRMAgents"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected = input.CRMWhatsappInvoiceCreationCRMAgentID.length == systemInformationData.CRMAgents.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-briefcase-account"
              item-title="CRMAgentName"
              item-value="CRMAgentID"
              label="Filtrar por agente de venta"
              placeholder="Todos los agentes de venta"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected" 
                  @update:model-value="input.CRMWhatsappInvoiceCreationCRMAgentID = input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected ? systemInformationData.CRMAgents.map(CRMAgent => CRMAgent.CRMAgentID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappInvoiceCreationCRMAgentID.includes(item.value)"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappInvoiceCreationCRMAgentID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <v-chip :color="item.raw.CRMAgentColor" variant="flat" elevation="2" label style="margin-top: 5px; margin-bottom: 5px;">
                      <div style="display: flex; align-items: center;">
                        <img :src="item.raw.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                        <p>{{ item.raw.CRMAgentName }}</p>
                      </div>
                    </v-chip>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentColor : 'primary'" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="item.raw.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>{{ item.raw.CRMAgentName }}</p>
                  </div>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMWhatsappInvoiceCreationCRMAgentID = input.CRMWhatsappInvoiceCreationCRMAgentID.filter(CRMAgentID => CRMAgentID != item.value); input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappInvoiceCreationCRMAgentID.length - 3 }} agente{{ input.CRMWhatsappInvoiceCreationCRMAgentID.length - 3 == 1 ? '' : 's' }} de venta)</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El agente de venta de la orden. Si se coloca al menos un agente de venta, se buscarán todas las ordenes creadas por el o los agentes de venta seleccionados. Al presionar el ícono de la derecha se seleccionan todos los agentes de venta disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappInvoiceShippingMethod"
              v-model="input.CRMWhatsappInvoiceShippingMethod"
              v-model:search="input.CRMWhatsappInvoiceShippingMethodSearch"
              :items="display.CRMWhatsappInvoiceShippingMethod"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allCRMWhatsappInvoiceShippingMethodSelected = input.CRMWhatsappInvoiceShippingMethod.length == display.CRMWhatsappInvoiceShippingMethod.filter(state => state != null).length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-source-branch"
              label="Filtrar por método de entrega"
              placeholder="Todos los métodos de entrega"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMWhatsappInvoiceShippingMethodSelected" 
                  @update:model-value="input.CRMWhatsappInvoiceShippingMethod = input.allCRMWhatsappInvoiceShippingMethodSelected ? display.CRMWhatsappInvoiceShippingMethod : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappInvoiceShippingMethod.includes(item.value)"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappInvoiceShippingMethod.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMWhatsappInvoiceShippingMethod = input.CRMWhatsappInvoiceShippingMethod.filter(CRMWhatsappInvoiceShippingMethod => CRMWhatsappInvoiceShippingMethod != item.value); input.allCRMWhatsappInvoiceShippingMethodSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappInvoiceShippingMethod.length - 3 }} {{ input.CRMWhatsappInvoiceShippingMethod.length - 3 == 1 ? 'método de entrega' : 'métodos de entrega' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El método de entrega de la orden. Si se coloca al menos un método de entrega, se buscarán todas las ordenes con el o los métodos de entrega seleccionados. Al presionar el ícono de la derecha se seleccionan todos los métodos de entrega disponibles</span>
        </v-tooltip>
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros por producto:</strong></span>
          <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
        </div>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productID"
              v-model="input.productID"
              v-model:search="input.productIDSearch"
              :items="display.product"
              @keydown.enter.prevent="scanProduct()"
              @update:model-value="updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-package"
              label="Filtrar por producto"
              placeholder="Todos los productos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productID"
              item-title="productAutocomplete"
              clearable
              hide-no-data
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:chip="{ item }">
                <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ item.raw.productName}}</p>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productID == item.value"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productID == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <div>
                      <p>{{ item.raw.productName }}</p>
                      <p style="font-size: x-small; color: #9e9e9e;"><strong>{{ item.raw.productID }}</strong></p>
                    </div>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">Si se coloca un producto, se buscarán todas las ordenes que incluyan el producto seleccionado</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productCategoryID"
              v-model="input.productCategoryID"
              v-model:search="input.productCategoryIDSearch"
              :items="display.productCategory"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allProductCategoryIDSelected = input.productCategoryID.length == display.productCategory.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-cog"
              label="Filtrar por categoría"
              placeholder="Todas las categorías"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productCategoryID"
              item-title="productCategoryName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductCategoryIDSelected"
                  @update:model-value="input.productCategoryID = input.allProductCategoryIDSelected ? display.productCategory.map(productCategory => productCategory.productCategoryID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productCategoryID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productCategoryID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productCategoryID = input.productCategoryID.filter(productCategoryID => productCategoryID != item.value); input.allProductCategoryIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productCategoryID.length - 3 }} {{ input.productCategoryID.length - 3 == 1 ? 'categoría de producto' : 'categorías de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La categoría del producto. Si se coloca al menos una categoría de producto, se buscarán todas las ordenes que incluyan al menos un producto con la o las categorías de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las categorías de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productBrandID"
              v-model="input.productBrandID"
              v-model:search="input.productBrandIDSearch"
              :items="display.productBrand"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allProductBrandIDSelected = input.productBrandID.length == display.productBrand.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-archive"
              label="Filtrar por marca"
              placeholder="Todas las marcas"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productBrandID"
              item-title="productBrandName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductBrandIDSelected" 
                  @update:model-value="input.productBrandID = input.allProductBrandIDSelected ? display.productBrand.map(productBrand => productBrand.productBrandID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productBrandID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productBrandID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productBrandID = input.productBrandID.filter(productBrandID => productBrandID != item.value); input.allProductBrandIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productBrandID.length - 3 }} {{ input.productBrandID.length - 3 == 1 ? 'marca de producto' : 'marcas de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La marca del producto. Si se coloca al menos una marca de producto, se buscarán todas las ordenes que incluyan al menos un producto con la o las marcas de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las marcas de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productModelID"
              v-model="input.productModelID"
              v-model:search="input.productModelIDSearch"
              :items="display.productModel"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allProductModelIDSelected = input.productModelID.length == display.productModel.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-checkbox-blank"
              label="Filtrar por modelo"
              placeholder="Todas los modelos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productModelID"
              item-title="productModelName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductModelIDSelected" 
                  @update:model-value="input.productModelID = input.allProductModelIDSelected ? display.productModel.map(productModel => productModel.productModelID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productModelID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productModelID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productModelID = input.productModelID.filter(productModelID => productModelID != item.value); input.allProductModelIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productModelID.length - 3 }} {{ input.productModelID.length - 3 == 1 ? 'modelo de producto' : 'modelos de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La modelo del producto. Si se coloca al menos una modelo de producto, se buscarán todas las ordenes que incluyan al menos un producto con la o las modelos de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las modelos de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productFlavorID"
              v-model="input.productFlavorID"
              v-model:search="input.productFlavorIDSearch"
              :items="display.productFlavor"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allProductFlavorIDSelected = input.productFlavorID.length == display.productFlavor.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-water"
              label="Filtrar por sabor"
              placeholder="Todos los sabores"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productFlavorID"
              item-title="productFlavorName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductFlavorIDSelected" 
                  @update:model-value="input.productFlavorID = input.allProductFlavorIDSelected ? display.productFlavor.map(productFlavor => productFlavor.productFlavorID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productFlavorID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productFlavorID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productFlavorID = input.productFlavorID.filter(productFlavorID => productFlavorID != item.value); input.allProductFlavorIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productFlavorID.length - 3 }} {{ input.productFlavorID.length - 3 == 1 ? 'sabor de producto' : 'sabores de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El sabor del producto. Si se coloca al menos una sabor de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los sabores de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los sabores de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productNicotineLevelID"
              v-model="input.productNicotineLevelID"
              v-model:search="input.productNicotineLevelIDSearch"
              :items="display.productNicotineLevel"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allProductNicotineLevelIDSelected = input.productNicotineLevelID.length == display.productNicotineLevel.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-cloud"
              label="Filtrar por nivel de nicotina"
              placeholder="Todos los niveles de nicotina"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productNicotineLevelID"
              item-title="productNicotineLevelName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductNicotineLevelIDSelected" 
                  @update:model-value="input.productNicotineLevelID = input.allProductNicotineLevelIDSelected ? display.productNicotineLevel.map(productNicotineLevel => productNicotineLevel.productNicotineLevelID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productNicotineLevelID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productNicotineLevelID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productNicotineLevelID = input.productNicotineLevelID.filter(productNicotineLevelID => productNicotineLevelID != item.value); input.allProductNicotineLevelIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productNicotineLevelID.length - 3 }} {{ input.productNicotineLevelID.length - 3 == 1 ? 'nivel de nicotina de producto' : 'niveles de nicotina de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El nivel de nicotina del producto. Si se coloca al menos una nivel de nicotina de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los niveles de nicotina de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los niveles de nicotina de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productSizeID"
              v-model="input.productSizeID"
              v-model:search="input.productSizeIDSearch"
              :items="display.productSize"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allProductSizeIDSelected = input.productSizeID.length == display.productSize.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-signal"
              label="Filtrar por tamaño"
              placeholder="Todos los tamaños"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productSizeID"
              item-title="productSizeName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductSizeIDSelected" 
                  @update:model-value="input.productSizeID = input.allProductSizeIDSelected ? display.productSize.map(productSize => productSize.productSizeID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productSizeID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productSizeID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productSizeID = input.productSizeID.filter(productSizeID => productSizeID != item.value); input.allProductSizeIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productSizeID.length - 3 }} {{ input.productSizeID.length - 3 == 1 ? 'tamaño de producto' : 'tamaños de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El nivel de nicotina del producto. Si se coloca al menos una nivel de nicotina de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los niveles de nicotina de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los niveles de nicotina de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productProviderID"
              v-model="input.productProviderID"
              v-model:search="input.productProviderIDSearch"
              :items="display.productProvider"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allProductProviderIDSelected = input.productProviderID.length == display.productProvider.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-briefcase"
              label="Filtrar por proveedor"
              placeholder="Todos los proveedores"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productProviderID"
              item-title="productProviderName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductProviderIDSelected" 
                  @update:model-value="input.productProviderID = input.allProductProviderIDSelected ? display.productProvider.map(productProvider => productProvider.productProviderID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productProviderID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productProviderID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productProviderID = input.productProviderID.filter(productProviderID => productProviderID != item.value); input.allProductProviderIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productProviderID.length - 3 }} {{ input.productProviderID.length - 3 == 1 ? 'proveedor de producto' : 'proveedores de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El proveedor del producto. Si se coloca al menos una proveedor de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los proveedores de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los proveedores de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productTagID"
              v-model="input.productTagID"
              v-model:search="input.productTagIDSearch"
              :items="display.productTag"
              @keydown.enter.prevent="selectCRMProductSaleFromCRMProductSaleView()"
              @update:model-value="input.allProductTagIDSelected = input.productTagID.length == display.productTag.length; updateURLSearchQuery();"
              :loading="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView"
              prepend-inner-icon="mdi-tag"
              label="Filtrar por tag"
              placeholder="Todos los tags"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productTagID"
              item-title="productTagName"
              clearable
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductTagIDSelected" 
                  @update:model-value="input.productTagID = input.allProductTagIDSelected ? display.productTag.map(productTag => productTag.productTagID) : []; updateURLSearchQuery();"
                  density="compact" 
                  hide-details
                  class="hoverableElement"
                ></v-checkbox-btn>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.productTagID.includes(item.value)"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.productTagID.includes(item.value)"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 3" variant="flat" elevation="2" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productTagID = input.productTagID.filter(productTagID => productTagID != item.value); input.allProductTagIDSelected = false; updateURLSearchQuery();" class="hoverableElement">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 3" style="color: #9e9e9e; font-size: small;">(+{{ input.productTagID.length - 3 }} {{ input.productTagID.length - 3 == 1 ? 'tag de producto' : 'tags de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El tag del producto. Si se coloca al menos una tag de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los tags de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todos los tags de producto disponibles</span>
        </v-tooltip>
      </div>
      <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
      <v-card color="primary" elevation="0" rounded="0" style="width: 100%; height: 120px; padding: 15px; overflow: hidden; align-items: center; justify-content: center;">
        <v-btn 
          @click="selectCRMProductSaleFromCRMProductSaleView()"
          :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView" 
          color="indigo"
          block
          class="hoverableText"
        >
          <v-icon size="large" style="margin-right: 10px;">mdi-magnify</v-icon>
          <h3>BUSCAR</h3>
        </v-btn>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="1000" location="top">
          <template v-slot:activator="{ props }">
            <v-btn 
              v-bind="props" 
              @click="setDefaultValues()"
              :disabled="loader.getSystemInformationData || loader.selectProductSearchParameters || loader.selectCRMProductSaleFromCRMProductSaleView" 
              color="secondary"
              block
              class="hoverableText"
              style="margin-top: 15px;"
            >
              <v-icon size="large" style="margin-right: 10px;">mdi-backspace</v-icon>
              <h3>LIMPIAR</h3>
            </v-btn>
          </template>
          <span style="width: 400px; display: block;">Al presionar este botón, se limpiarán los resultados de la búsqueda actual, y se reestablecerán todos los filtros de búsqueda a sus valores por defecto</span>
        </v-tooltip>
      </v-card>
    </v-card>
    <div class="contentContainer">
      <template v-if="loader.selectCRMProductSaleFromCRMProductSaleView">
        <AppLoaderScreen
          :key="Math.random() * 1000000"
          :appLogoSize="'x-small'"
          :loadingText="'Cargando tendencia de venta'"
          :dotsToAnimate="3"
          :hints="$assets.default.hints.CRMProductSaleView"
          style="width: 100%; height: 100%;"
        ></AppLoaderScreen>
      </template>
      <template v-else-if="computed_sortedProductCategory.length > 0">
        <v-card elevation="0" rounded="0" color="primary" style="width: 100%; padding: 15px;">
          <div class="cardContainer">
            <v-card color="indigo" style="padding: 5px; display: flex; flex-direction: column; gap: 5px;">
              <div style="display: flex; gap: 10px; align-items: center; justify-content: center;">
                <v-icon size="large">mdi-{{ input.show == 'productAmount' ? 'counter' : 'cash' }}</v-icon>
                <h2>{{ input.show == 'productAmount' ? 'UNIDADES' : 'MONTO' }}</h2>
              </div>
              <div style="text-align: center;">
                <template v-if="input.show == 'productAmount'">
                  <p><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(computed_sortedProductCategory.reduce((productCategoryAmount, productCategory) => productCategoryAmount + productCategory.productAmount, 0)) }}</strong></p>
                </template>
                <template v-else>
                  <p><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((computed_sortedProductCategory.reduce((productCategoryAmount, productCategory) => productCategoryAmount + productCategory.productSale, 0) || 0) / 5) * 5) }}</strong></p>
                </template>
              </div>
            </v-card>
            <v-menu 
              :close-on-content-click="false"
              scrim 
              @contextmenu.prevent="null" 
              style="cursor: default; user-select: none;"
            >
              <template v-slot:activator="{ props }">
                <v-card v-bind="props" color="indigo" class="hoverableText" style="padding: 5px; display: flex; flex-direction: column; gap: 5px;">
                  <div style="display: flex; gap: 10px; align-items: center; justify-content: center;">
                    <v-icon size="large">mdi-cog</v-icon>
                    <h2>CATEGORÍA</h2>
                  </div>
                  <div style="text-align: center;">
                    <template v-if="input.show == 'productAmount'">
                      <p><strong>{{ computed_sortedProductCategory[0].productCategoryName }}</strong> ({{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(computed_sortedProductCategory[0].productAmount) }})</p>
                    </template>
                    <template v-else>
                      <p><strong>{{ computed_sortedProductCategory[0].productCategoryName }}</strong> (₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((computed_sortedProductCategory[0].productSale || 0) / 5) * 5) }})</p>
                    </template>
                  </div>
                </v-card>
              </template>
              <v-card style="max-height: 500px; overflow-y: auto; scrollbar-width: thin;">
                <v-list density="compact" style="overflow-x: hidden;">
                  <v-list-item
                    v-for="(productCategory, productCategoryIndex) in computed_sortedProductCategory"
                    :key="productCategory.productCategoryID"
                    @click.prevent="null"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-tooltip 
                        :disabled="systemInformationData.tooltipDisabled"
                        text="Ranking de la categoría"
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :color="productCategoryIndex < computed_sortedProductCategory.length / 3 ? (input.sort == 'DESC' ? 'success' : 'error') : productCategoryIndex < (2 * computed_sortedProductCategory.length) / 3 ? 'warning' : (input.sort == 'DESC' ? 'error' : 'success')"
                            variant="flat"
                            elevation="2"
                            label
                            class="hoverableText"
                            style="margin-right: 10px;"
                          >
                            <v-icon size="small" start>mdi-medal</v-icon>
                            <p style="font-size: small;"><strong>{{ productCategoryIndex + 1 }}</strong></p>
                          </v-chip>
                        </template>
                      </v-tooltip>
                    </template>
                    <p style="margin-right: 20px;">{{ productCategory.productCategoryName }}</p>
                    <template v-slot:append>
                      <div style="display: flex; align-items: center; gap: 5px;">
                        <v-tooltip 
                          :disabled="systemInformationData.tooltipDisabled"
                          :text="`Unidad${productCategory.productAmount == 1 ? '': 'es'} vendida${productCategory.productAmount == 1 ? '': 's'}`" 
                          location="top"
                        >
                          <template v-slot:activator="{ props }">
                            <v-chip 
                              v-bind="props" 
                              color="primary" 
                              variant="flat" 
                              elevation="2" 
                              label 
                              class="hoverableText"
                            >
                              <v-icon size="small" start>mdi-{{ input.show == 'productAmount' ? 'counter' : 'cash' }}</v-icon>
                              <template v-if="input.show == 'productAmount'">
                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productCategory.productAmount) }}</strong></p>
                              </template>
                              <template v-else>
                                <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((productCategory.productSale || 0) / 5) * 5) }}</strong></p>
                              </template>
                            </v-chip>
                          </template>
                        </v-tooltip>
                        <template v-if="input.show == 'productAmount'">
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-chip 
                                v-bind="props" 
                                :color="(productCategory.offsetProductAmount == 0 || productCategory.productAmount == productCategory.offsetProductAmount) ? 'primary' : productCategory.productAmount > productCategory.offsetProductAmount ? 'success' : 'error'" 
                                variant="flat" 
                                elevation="2" 
                                label
                                class="hoverableText"
                              >
                                <v-icon size="small" start>
                                  {{ (productCategory.offsetProductAmount == 0 || productCategory.productAmount == productCategory.offsetProductAmount) ? 'mdi-trending-neutral' : productCategory.productAmount > productCategory.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                </v-icon>
                                <template v-if="productCategory.productAmount == 0 && productCategory.offsetProductAmount == 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productCategory.productAmount == 0 && productCategory.offsetProductAmount > 0">
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                </template>
                                <template v-else-if="productCategory.offsetProductAmount == 0 && productCategory.productAmount > 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productCategory.productAmount == productCategory.offsetProductAmount">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productCategory.productAmount > productCategory.offsetProductAmount">
                                  <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productCategory.productAmount - productCategory.offsetProductAmount) / productCategory.offsetProductAmount) * 100)) }} %</strong></p>
                                </template>
                                <template v-else>
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productCategory.productAmount - productCategory.offsetProductAmount) / productCategory.offsetProductAmount) * 100)) }} %</strong></p>
                                </template>
                              </v-chip>
                            </template>
                            <div>
                              <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productCategory.productAmount) }}</p>
                              <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productCategory.offsetProductAmount) }}</p>
                              <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ productCategory.productAmount > productCategory.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(productCategory.productAmount - productCategory.offsetProductAmount)) }}</p>
                            </div>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-chip 
                                v-bind="props" 
                                :color="(productCategory.offsetProductSale == 0 || productCategory.productSale == productCategory.offsetProductSale) ? 'primary' : productCategory.productSale > productCategory.offsetProductSale ? 'success' : 'error'" 
                                variant="flat" 
                                elevation="2" 
                                label
                                class="hoverableText"
                              >
                                <v-icon size="small" start>
                                  {{ (productCategory.offsetProductSale == 0 || productCategory.productSale == productCategory.offsetProductSale) ? 'mdi-trending-neutral' : productCategory.productSale > productCategory.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                </v-icon>
                                <template v-if="productCategory.productSale == 0 && productCategory.offsetProductSale == 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productCategory.productSale == 0 && productCategory.offsetProductSale > 0">
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                </template>
                                <template v-else-if="productCategory.offsetProductSale == 0 && productCategory.productSale > 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productCategory.productSale == productCategory.offsetProductSale">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productCategory.productSale > productCategory.offsetProductSale">
                                  <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productCategory.productSale - productCategory.offsetProductSale) / productCategory.offsetProductSale) * 100)) }} %</strong></p>
                                </template>
                                <template v-else>
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productCategory.productSale - productCategory.offsetProductSale) / productCategory.offsetProductSale) * 100)) }} %</strong></p>
                                </template>
                              </v-chip>
                            </template>
                            <div>
                              <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productCategory.productSale || 0) / 5) * 5) }}</p>
                              <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productCategory.offsetProductSale || 0) / 5) * 5) }}</p>
                              <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ productCategory.productSale > productCategory.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(productCategory.productSale - productCategory.offsetProductSale) || 0) / 5) * 5) }}</p>
                            </div>
                          </v-tooltip>
                        </template>
                      </div>
                    </template>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-menu 
              :close-on-content-click="false"
              scrim 
              @contextmenu.prevent="null" 
              style="cursor: default; user-select: none;"
            >
              <template v-slot:activator="{ props }">
                <v-card v-bind="props" color="indigo" class="hoverableText" style="padding: 5px; display: flex; flex-direction: column; gap: 5px;">
                  <div style="display: flex; gap: 10px; align-items: center; justify-content: center;">
                    <v-icon size="large">mdi-package</v-icon>
                    <h2>MARCA</h2>
                  </div>
                  <div style="text-align: center;">
                    <template v-if="input.show == 'productAmount'">
                      <p><strong>{{ computed_sortedProductBrand[0].productBrandName }}</strong> ({{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(computed_sortedProductBrand[0].productAmount) }})</p>
                    </template>
                    <template v-else>
                      <p><strong>{{ computed_sortedProductBrand[0].productBrandName }}</strong> (₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((computed_sortedProductBrand[0].productSale || 0) / 5) * 5) }})</p>
                    </template>
                  </div>
                </v-card>
              </template>
              <v-card style="max-height: 500px; overflow-y: auto; scrollbar-width: thin;">
                <v-list density="compact" style="overflow-x: hidden;">
                  <v-list-item
                    v-for="(productBrand, productBrandIndex) in computed_sortedProductBrand"
                    :key="productBrand.productBrandID"
                    @click.prevent="null"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-tooltip 
                        :disabled="systemInformationData.tooltipDisabled"
                        text="Ranking de la marca"
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :color="productBrandIndex < computed_sortedProductBrand.length / 3 ? (input.sort == 'DESC' ? 'success' : 'error') : productBrandIndex < (2 * computed_sortedProductBrand.length) / 3 ? 'warning' : (input.sort == 'DESC' ? 'error' : 'success')"
                            variant="flat"
                            elevation="2"
                            label
                            class="hoverableText"
                            style="margin-right: 10px;"
                          >
                            <v-icon size="small" start>mdi-medal</v-icon>
                            <p style="font-size: small;"><strong>{{ productBrandIndex + 1 }}</strong></p>
                          </v-chip>
                        </template>
                      </v-tooltip>
                    </template>
                    <p style="margin-right: 20px;">{{ productBrand.productBrandName }}</p>
                    <template v-slot:append>
                      <div style="display: flex; align-items: center; gap: 5px;">
                        <v-tooltip 
                          :disabled="systemInformationData.tooltipDisabled"
                          :text="`Unidad${productBrand.productAmount == 1 ? '': 'es'} vendida${productBrand.productAmount == 1 ? '': 's'}`" 
                          location="top"
                        >
                          <template v-slot:activator="{ props }">
                            <v-chip 
                              v-bind="props" 
                              color="primary" 
                              variant="flat" 
                              elevation="2" 
                              label 
                              class="hoverableText"
                            >
                              <v-icon size="small" start>mdi-{{ input.show == 'productAmount' ? 'counter' : 'cash' }}</v-icon>
                              <template v-if="input.show == 'productAmount'">
                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productBrand.productAmount) }}</strong></p>
                              </template>
                              <template v-else>
                                <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((productBrand.productSale || 0) / 5) * 5) }}</strong></p>
                              </template>
                            </v-chip>
                          </template>
                        </v-tooltip>
                        <template v-if="input.show == 'productAmount'">
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-chip 
                                v-bind="props" 
                                :color="(productBrand.offsetProductAmount == 0 || productBrand.productAmount == productBrand.offsetProductAmount) ? 'primary' : productBrand.productAmount > productBrand.offsetProductAmount ? 'success' : 'error'" 
                                variant="flat" 
                                elevation="2" 
                                label
                                class="hoverableText"
                              >
                                <v-icon size="small" start>
                                  {{ (productBrand.offsetProductAmount == 0 || productBrand.productAmount == productBrand.offsetProductAmount) ? 'mdi-trending-neutral' : productBrand.productAmount > productBrand.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                </v-icon>
                                <template v-if="productBrand.productAmount == 0 && productBrand.offsetProductAmount == 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productBrand.productAmount == 0 && productBrand.offsetProductAmount > 0">
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                </template>
                                <template v-else-if="productBrand.offsetProductAmount == 0 && productBrand.productAmount > 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productBrand.productAmount == productBrand.offsetProductAmount">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productBrand.productAmount > productBrand.offsetProductAmount">
                                  <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productBrand.productAmount - productBrand.offsetProductAmount) / productBrand.offsetProductAmount) * 100)) }} %</strong></p>
                                </template>
                                <template v-else>
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productBrand.productAmount - productBrand.offsetProductAmount) / productBrand.offsetProductAmount) * 100)) }} %</strong></p>
                                </template>
                              </v-chip>
                            </template>
                            <div>
                              <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productBrand.productAmount) }}</p>
                              <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productBrand.offsetProductAmount) }}</p>
                              <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ productBrand.productAmount > productBrand.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(productBrand.productAmount - productBrand.offsetProductAmount)) }}</p>
                            </div>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-chip 
                                v-bind="props" 
                                :color="(productBrand.offsetProductSale == 0 || productBrand.productSale == productBrand.offsetProductSale) ? 'primary' : productBrand.productSale > productBrand.offsetProductSale ? 'success' : 'error'" 
                                variant="flat" 
                                elevation="2" 
                                label
                                class="hoverableText"
                              >
                                <v-icon size="small" start>
                                  {{ (productBrand.offsetProductSale == 0 || productBrand.productSale == productBrand.offsetProductSale) ? 'mdi-trending-neutral' : productBrand.productSale > productBrand.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                </v-icon>
                                <template v-if="productBrand.productSale == 0 && productBrand.offsetProductSale == 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productBrand.productSale == 0 && productBrand.offsetProductSale > 0">
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                </template>
                                <template v-else-if="productBrand.offsetProductSale == 0 && productBrand.productSale > 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productBrand.productSale == productBrand.offsetProductSale">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productBrand.productSale > productBrand.offsetProductSale">
                                  <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productBrand.productSale - productBrand.offsetProductSale) / productBrand.offsetProductSale) * 100)) }} %</strong></p>
                                </template>
                                <template v-else>
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productBrand.productSale - productBrand.offsetProductSale) / productBrand.offsetProductSale) * 100)) }} %</strong></p>
                                </template>
                              </v-chip>
                            </template>
                            <div>
                              <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productBrand.productSale || 0) / 5) * 5) }}</p>
                              <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productBrand.offsetProductSale || 0) / 5) * 5) }}</p>
                              <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ productBrand.productSale > productBrand.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(productBrand.productSale - productBrand.offsetProductSale) || 0) / 5) * 5) }}</p>
                            </div>
                          </v-tooltip>
                        </template>
                      </div>
                    </template>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-menu 
              :close-on-content-click="false"
              scrim 
              @contextmenu.prevent="null" 
              style="cursor: default; user-select: none;"
            >
              <template v-slot:activator="{ props }">
                <v-card v-bind="props" color="indigo" class="hoverableText" style="padding: 5px; display: flex; flex-direction: column; gap: 5px;">
                  <div style="display: flex; gap: 10px; align-items: center; justify-content: center;">
                    <v-icon size="large">mdi-checkbox-blank</v-icon>
                    <h2>MODELO</h2>
                  </div>
                  <div style="text-align: center;">
                    <template v-if="input.show == 'productAmount'">
                      <p><strong>{{ computed_sortedProductModel[0].productModelName }}</strong> ({{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(computed_sortedProductModel[0].productAmount) }})</p>
                    </template>
                    <template v-else>
                      <p><strong>{{ computed_sortedProductModel[0].productModelName }}</strong> (₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((computed_sortedProductModel[0].productSale || 0) / 5) * 5) }})</p>
                    </template>
                  </div>
                </v-card>
              </template>
              <v-card style="max-height: 500px; overflow-y: auto; scrollbar-width: thin;">
                <v-list density="compact" style="overflow-x: hidden;">
                  <v-list-item
                    v-for="(productModel, productModelIndex) in computed_sortedProductModel"
                    :key="productModel.productModelID"
                    @click.prevent="null"
                    class="hoverableText"
                  >
                    <template v-slot:prepend>
                      <v-tooltip 
                        :disabled="systemInformationData.tooltipDisabled"
                        text="Ranking de la marca"
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-chip
                            v-bind="props"
                            :color="productModelIndex < computed_sortedProductModel.length / 3 ? (input.sort == 'DESC' ? 'success' : 'error') : productModelIndex < (2 * computed_sortedProductModel.length) / 3 ? 'warning' : (input.sort == 'DESC' ? 'error' : 'success')"
                            variant="flat"
                            elevation="2"
                            label
                            class="hoverableText"
                            style="margin-right: 10px;"
                          >
                            <v-icon size="small" start>mdi-medal</v-icon>
                            <p style="font-size: small;"><strong>{{ productModelIndex + 1 }}</strong></p>
                          </v-chip>
                        </template>
                      </v-tooltip>
                    </template>
                    <p style="margin-right: 20px;">{{ productModel.productModelName }}</p>
                    <template v-slot:append>
                      <div style="display: flex; align-items: center; gap: 5px;">
                        <v-tooltip 
                          :disabled="systemInformationData.tooltipDisabled"
                          :text="`Unidad${productModel.productAmount == 1 ? '': 'es'} vendida${productModel.productAmount == 1 ? '': 's'}`" 
                          location="top"
                        >
                          <template v-slot:activator="{ props }">
                            <v-chip 
                              v-bind="props" 
                              color="primary" 
                              variant="flat" 
                              elevation="2" 
                              label 
                              class="hoverableText"
                            >
                              <v-icon size="small" start>mdi-counter</v-icon>
                              <template v-if="input.show == 'productAmount'">
                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productModel.productAmount) }}</strong></p>
                              </template>
                              <template v-else>
                                <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((productModel.productSale || 0) / 5) * 5) }}</strong></p>
                              </template>
                            </v-chip>
                          </template>
                        </v-tooltip>
                        <template v-if="input.show == 'productAmount'">
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-chip 
                                v-bind="props" 
                                :color="(productModel.offsetProductAmount == 0 || productModel.productAmount == productModel.offsetProductAmount) ? 'primary' : productModel.productAmount > productModel.offsetProductAmount ? 'success' : 'error'" 
                                variant="flat" 
                                elevation="2" 
                                label
                                class="hoverableText"
                              >
                                <v-icon size="small" start>
                                  {{ (productModel.offsetProductAmount == 0 || productModel.productAmount == productModel.offsetProductAmount) ? 'mdi-trending-neutral' : productModel.productAmount > productModel.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                </v-icon>
                                <template v-if="productModel.productAmount == 0 && productModel.offsetProductAmount == 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productModel.productAmount == 0 && productModel.offsetProductAmount > 0">
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                </template>
                                <template v-else-if="productModel.offsetProductAmount == 0 && productModel.productAmount > 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productModel.productAmount == productModel.offsetProductAmount">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productModel.productAmount > productModel.offsetProductAmount">
                                  <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productModel.productAmount - productModel.offsetProductAmount) / productModel.offsetProductAmount) * 100)) }} %</strong></p>
                                </template>
                                <template v-else>
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productModel.productAmount - productModel.offsetProductAmount) / productModel.offsetProductAmount) * 100)) }} %</strong></p>
                                </template>
                              </v-chip>
                            </template>
                            <div>
                              <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productModel.productAmount) }}</p>
                              <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productModel.offsetProductAmount) }}</p>
                              <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ productModel.productAmount > productModel.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(productModel.productAmount - productModel.offsetProductAmount)) }}</p>
                            </div>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-chip 
                                v-bind="props" 
                                :color="(productModel.offsetProductSale == 0 || productModel.productSale == productModel.offsetProductSale) ? 'primary' : productModel.productSale > productModel.offsetProductSale ? 'success' : 'error'" 
                                variant="flat" 
                                elevation="2" 
                                label
                                class="hoverableText"
                              >
                                <v-icon size="small" start>
                                  {{ (productModel.offsetProductSale == 0 || productModel.productSale == productModel.offsetProductSale) ? 'mdi-trending-neutral' : productModel.productSale > productModel.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                </v-icon>
                                <template v-if="productModel.productSale == 0 && productModel.offsetProductSale == 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productModel.productSale == 0 && productModel.offsetProductSale > 0">
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                </template>
                                <template v-else-if="productModel.offsetProductSale == 0 && productModel.productSale > 0">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productModel.productSale == productModel.offsetProductSale">
                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                </template>
                                <template v-else-if="productModel.productSale > productModel.offsetProductSale">
                                  <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productModel.productSale - productModel.offsetProductSale) / productModel.offsetProductSale) * 100)) }} %</strong></p>
                                </template>
                                <template v-else>
                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productModel.productSale - productModel.offsetProductSale) / productModel.offsetProductSale) * 100)) }} %</strong></p>
                                </template>
                              </v-chip>
                            </template>
                            <div>
                              <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productModel.productSale || 0) / 5) * 5) }}</p>
                              <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productModel.offsetProductSale || 0) / 5) * 5) }}</p>
                              <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ productModel.productSale > productModel.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(productModel.productSale - productModel.offsetProductSale) || 0) / 5) * 5) }}</p>
                            </div>
                          </v-tooltip>
                        </template>
                      </div>
                    </template>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </div>
          <div class="twoColumnsContainer">
            <v-select
              v-model="input.show"
              :items="[{title: 'Cantidad de unidades vendidas', value: 'productAmount'}, {title: 'Monto de venta', value: 'productTotal'}]"
              label="Mostrar"
              color="indigo"
              variant="outlined"
              density="compact"
              hide-details
            >
              <template v-slot:prepend-inner>
                <v-icon color="indigo">mdi-filter-variant</v-icon>
              </template>
              <template v-slot:prepend v-if="navigation.searchVisible == false">
                <v-icon @click="navigation.searchVisible = true" class="hoverableElement">mdi-arrow-right-bottom-bold</v-icon>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.show == item.value"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.show == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
            </v-select>
            <v-select
              v-model="input.sort"
              :items="[{title: 'De mayor a menor', value: 'DESC'}, {title: 'De menor a mayor', value: 'ASC'}]"
              label="Ordenar por"
              color="indigo"
              variant="outlined"
              density="compact"
              hide-details
            >
              <template v-slot:prepend-inner>
                <v-icon color="indigo">mdi-sort</v-icon>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.sort == item.value"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.sort == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <p>{{ item.title }}</p>
                  </v-list-item>
                </v-list>
              </template>
            </v-select>
          </div>
          <div class="twoColumnsContainer">
            <p style="font-size: small; color: #9e9e9e"><strong>Fecha de consulta: </strong>del {{ $displayFunctions.default.fromDatetimeToDDMMYYYY(display.startDate) }} al {{ $displayFunctions.default.fromDatetimeToDDMMYYYY(display.endDate) }}</p>
            <p style="font-size: small; color: #9e9e9e"><strong>Fecha de comparación: </strong>del {{ $displayFunctions.default.fromDatetimeToDDMMYYYY(display.offsetStartDate) }} al {{ $displayFunctions.default.fromDatetimeToDDMMYYYY(display.offsetEndDate) }}</p>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>

        <div style="flex: 1; overflow-y: auto; scrollbar-width: thin; padding: 10px; display: flex; flex-direction: column; gap: 10px;">
          <v-expansion-panels
            v-for="productCategory in computed_sortedProductCategory"
            :key="productCategory.productCategoryID"
          >
            <v-expansion-panel>
              <v-expansion-panel-title>
                <div style="width: 100%; display: flex; align-items: center;">
                  <h2>{{ productCategory.productCategoryName }}</h2>
                  <div style="display: flex; gap: 5px; margin-left: auto; margin-right: 10px; align-items: center;">
                    <template v-if="input.show == 'productAmount'">
                      <v-tooltip 
                        :disabled="systemInformationData.tooltipDisabled" 
                        :text="`Unidad${productCategory.productAmount == 1 ? '': 'es'} vendida${productCategory.productAmount == 1 ? '': 's'}`"
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-chip 
                            v-bind="props" 
                            color="primary" 
                            variant="flat"
                            elevation="2"
                            label 
                            class="hoverableText"
                          >
                            <v-icon size="small" start>mdi-counter</v-icon>
                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productCategory.productAmount) }}</strong></p>
                          </v-chip>
                        </template>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip 
                        :disabled="systemInformationData.tooltipDisabled" 
                        :text="`Monto de venta${productCategory.productSale == 1 ? '': 's'}`"
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-chip 
                            v-bind="props" 
                            color="primary" 
                            variant="flat"
                            elevation="2"
                            label 
                            class="hoverableText"
                          >
                            <v-icon size="small" start>mdi-cash</v-icon>
                            <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((productCategory.productSale || 0) / 5) * 5) }}</strong></p>
                          </v-chip>
                        </template>
                      </v-tooltip>
                    </template>
                    <v-menu 
                      :close-on-content-click="false" 
                      scrim 
                      @contextmenu.prevent="null"
                      style="cursor: default; user-select: none;">
                      <template v-slot:activator="{ props }">
                        <v-chip 
                          v-bind="props" 
                          color="primary" 
                          variant="flat" 
                          elevation="2" 
                          label 
                          class="hoverableText"
                        >
                          <v-icon size="small">mdi-briefcase-account</v-icon>
                        </v-chip>
                      </template>
                      <v-list density="compact" style="padding: 0px 5px; margin: 0; max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                        <template 
                          v-for="([CRMAgentID, CRMAgent]) in Object.entries(productCategory.byCRMAgent).sort((CRMAgentA, CRMAgentB) => input.show == 'productAmount' ? (input.sort == 'DESC' ? CRMAgentB[1].productAmount - CRMAgentA[1].productAmount : CRMAgentA[1].productAmount - CRMAgentB[1].productAmount) : (input.sort == 'DESC' ? CRMAgentB[1].productSale - CRMAgentA[1].productSale : CRMAgentA[1].productSale - CRMAgentB[1].productSale))" 
                          v-bind:key="CRMAgentID"
                        >
                          <v-list-item 
                            @click.prevent="null"  
                            class="hoverableText" 
                            style="padding: 0; margin: 0; overflow-x: hidden;"
                          >
                            <v-list-item-title>
                              <div style="display: flex; align-items: center; min-width: 400px; gap: 10px;">
                                <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID)">
                                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentColor || 'primary'" elevation="2" variant="flat" label>
                                    <div style="display: flex; align-items: center;">
                                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentName }}</p>
                                    </div>
                                  </v-chip>
                                </template>
                                <template v-else>
                                  <v-chip color="primary" elevation="2" variant="flat" label>
                                    <div style="display: flex; align-items: center;">
                                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                                      <p>No registrado</p>
                                    </div>
                                  </v-chip>
                                </template>
                                <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
                                  <template v-if="input.show == 'productAmount'">
                                    <v-tooltip 
                                      :disabled="systemInformationData.tooltipDisabled" 
                                      :text="`Unidad${CRMAgent.productAmount == 1 ? '': 'es'} vendida${CRMAgent.productAmount == 1 ? '': 's'}`" 
                                      location="top"
                                    >
                                      <template v-slot:activator="{ props }">
                                        <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                          <v-icon size="small" start>mdi-counter</v-icon>
                                          <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.productAmount) }}</strong></p>
                                        </v-chip>
                                      </template>
                                    </v-tooltip>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-chip 
                                          v-bind="props" 
                                          :color="(CRMAgent.offsetProductAmount == 0 || CRMAgent.productAmount == CRMAgent.offsetProductAmount) ? 'primary' : CRMAgent.productAmount > CRMAgent.offsetProductAmount ? 'success' : 'error'" 
                                          variant="flat" 
                                          elevation="2" 
                                          label
                                          class="hoverableText"
                                        >
                                          <v-icon size="small" start>
                                            {{ (CRMAgent.offsetProductAmount == 0 || CRMAgent.productAmount == CRMAgent.offsetProductAmount) ? 'mdi-trending-neutral' : CRMAgent.productAmount > CRMAgent.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                          </v-icon>
                                          <template v-if="CRMAgent.productAmount == 0 && CRMAgent.offsetProductAmount == 0">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMAgent.productAmount == 0 && CRMAgent.offsetProductAmount > 0">
                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMAgent.offsetProductAmount == 0 && CRMAgent.productAmount > 0">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMAgent.productAmount == CRMAgent.offsetProductAmount">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMAgent.productAmount > CRMAgent.offsetProductAmount">
                                            <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productAmount - CRMAgent.offsetProductAmount) / CRMAgent.offsetProductAmount) * 100)) }} %</strong></p>
                                          </template>
                                          <template v-else>
                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productAmount - CRMAgent.offsetProductAmount) / CRMAgent.offsetProductAmount) * 100)) }} %</strong></p>
                                          </template>
                                        </v-chip>
                                      </template>
                                      <div>
                                        <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.productAmount) }}</p>
                                        <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.offsetProductAmount) }}</p>
                                        <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ CRMAgent.productAmount > CRMAgent.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(CRMAgent.productAmount - CRMAgent.offsetProductAmount)) }}</p>
                                      </div>
                                    </v-tooltip>
                                  </template>
                                  <template v-else>
                                    <v-tooltip 
                                      :disabled="systemInformationData.tooltipDisabled" 
                                      :text="`Monto de venta${CRMAgent.productSale == 1 ? '': 's'}`" 
                                      location="top"
                                    >
                                      <template v-slot:activator="{ props }">
                                        <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                          <v-icon size="small" start>mdi-cash</v-icon>
                                          <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.productSale || 0) / 5) * 5) }}</strong></p>
                                        </v-chip>
                                      </template>
                                    </v-tooltip>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-chip 
                                          v-bind="props" 
                                          :color="(CRMAgent.offsetProductSale == 0 || CRMAgent.productSale == CRMAgent.offsetProductSale) ? 'primary' : CRMAgent.productSale > CRMAgent.offsetProductSale ? 'success' : 'error'" 
                                          variant="flat" 
                                          elevation="2" 
                                          label
                                          class="hoverableText"
                                        >
                                          <v-icon size="small" start>
                                            {{ (CRMAgent.offsetProductSale == 0 || CRMAgent.productSale == CRMAgent.offsetProductSale) ? 'mdi-trending-neutral' : CRMAgent.productSale > CRMAgent.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                          </v-icon>
                                          <template v-if="CRMAgent.productSale == 0 && CRMAgent.offsetProductSale == 0">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMAgent.productSale == 0 && CRMAgent.offsetProductSale > 0">
                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMAgent.offsetProductSale == 0 && CRMAgent.productSale > 0">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMAgent.productSale == CRMAgent.offsetProductSale">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMAgent.productSale > CRMAgent.offsetProductSale">
                                            <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productSale - CRMAgent.offsetProductSale) / CRMAgent.offsetProductSale) * 100)) }} %</strong></p>
                                          </template>
                                          <template v-else>
                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productSale - CRMAgent.offsetProductSale) / CRMAgent.offsetProductSale) * 100)) }} %</strong></p>
                                          </template>
                                        </v-chip>
                                      </template>
                                      <div>
                                        <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.productSale || 0) / 5) * 5) }}</p>
                                        <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.offsetProductSale || 0) / 5) * 5) }}</p>
                                        <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ CRMAgent.productSale > CRMAgent.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(CRMAgent.productSale - CRMAgent.offsetProductSale) || 0) / 5) * 5) }}</p>
                                      </div>
                                    </v-tooltip>
                                  </template>
                                </div>
                              </div>
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-menu>
                    <v-menu 
                      :close-on-content-click="false" 
                      scrim 
                      @contextmenu.prevent="null"
                      style="cursor: default; user-select: none;">
                      <template v-slot:activator="{ props }">
                        <v-chip 
                          v-bind="props" 
                          color="primary" 
                          variant="flat" 
                          elevation="2" 
                          label 
                          class="hoverableText"
                        >
                          <v-icon size="small">mdi-store</v-icon>
                        </v-chip>
                      </template>
                      <v-list density="compact" style="padding: 0px 5px; margin: 0; max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                        <template 
                          v-for="([CRMLocalityID, CRMLocality]) in Object.entries(productCategory.byCRMLocality).sort((CRMLocalityA, CRMLocalityB) => input.show == 'productAmount' ? (input.sort == 'DESC' ? CRMLocalityB[1].productAmount - CRMLocalityA[1].productAmount : CRMLocalityA[1].productAmount - CRMLocalityB[1].productAmount) : (input.sort == 'DESC' ? CRMLocalityB[1].productSale - CRMLocalityA[1].productSale : CRMLocalityA[1].productSale - CRMLocalityB[1].productSale))" 
                          v-bind:key="CRMLocalityID"
                        >
                          <v-list-item 
                            @click.prevent="null"  
                            class="hoverableText" 
                            style="padding: 0; margin: 0; overflow-x: hidden;"
                          >
                            <v-list-item-title>
                              <div style="display: flex; align-items: center; min-width: 400px; gap: 10px;">
                                <template v-if="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID)">
                                  <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID).CRMLocalityColor || 'primary'" elevation="2" variant="flat" label>
                                    <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID).CRMLocalityName }}</p>
                                  </v-chip>
                                </template>
                                <template v-else>
                                  <v-chip color="primary" elevation="2" variant="flat" label>
                                    <p>No registrada</p>
                                  </v-chip>
                                </template>
                                <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
                                  <template v-if="input.show == 'productAmount'">
                                    <v-tooltip 
                                      :disabled="systemInformationData.tooltipDisabled" 
                                      :text="`Unidad${CRMLocality.productAmount == 1 ? '': 'es'} vendida${CRMLocality.productAmount == 1 ? '': 's'}`" 
                                      location="top"
                                    >
                                      <template v-slot:activator="{ props }">
                                        <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                          <v-icon size="small" start>mdi-counter</v-icon>
                                          <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.productAmount) }}</strong></p>
                                        </v-chip>
                                      </template>
                                    </v-tooltip>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-chip 
                                          v-bind="props" 
                                          :color="(CRMLocality.offsetProductAmount == 0 || CRMLocality.productAmount == CRMLocality.offsetProductAmount) ? 'primary' : CRMLocality.productAmount > CRMLocality.offsetProductAmount ? 'success' : 'error'" 
                                          variant="flat" 
                                          elevation="2" 
                                          label
                                          class="hoverableText"
                                        >
                                          <v-icon size="small" start>
                                            {{ (CRMLocality.offsetProductAmount == 0 || CRMLocality.productAmount == CRMLocality.offsetProductAmount) ? 'mdi-trending-neutral' : CRMLocality.productAmount > CRMLocality.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                          </v-icon>
                                          <template v-if="CRMLocality.productAmount == 0 && CRMLocality.offsetProductAmount == 0">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMLocality.productAmount == 0 && CRMLocality.offsetProductAmount > 0">
                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMLocality.offsetProductAmount == 0 && CRMLocality.productAmount > 0">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMLocality.productAmount == CRMLocality.offsetProductAmount">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMLocality.productAmount > CRMLocality.offsetProductAmount">
                                            <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productAmount - CRMLocality.offsetProductAmount) / CRMLocality.offsetProductAmount) * 100)) }} %</strong></p>
                                          </template>
                                          <template v-else>
                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productAmount - CRMLocality.offsetProductAmount) / CRMLocality.offsetProductAmount) * 100)) }} %</strong></p>
                                          </template>
                                        </v-chip>
                                      </template>
                                      <div>
                                        <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.productAmount) }}</p>
                                        <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.offsetProductAmount) }}</p>
                                        <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ CRMLocality.productAmount > CRMLocality.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(CRMLocality.productAmount - CRMLocality.offsetProductAmount)) }}</p>
                                      </div>
                                    </v-tooltip>
                                  </template>
                                  <template v-else>
                                    <v-tooltip 
                                      :disabled="systemInformationData.tooltipDisabled" 
                                      :text="`Monto de venta${CRMLocality.productSale == 1 ? '': 's'}`" 
                                      location="top"
                                    >
                                      <template v-slot:activator="{ props }">
                                        <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                          <v-icon size="small" start>mdi-cash</v-icon>
                                          <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.productSale || 0) / 5) * 5) }}</strong></p>
                                        </v-chip>
                                      </template>
                                    </v-tooltip>
                                    <v-tooltip location="top">
                                      <template v-slot:activator="{ props }">
                                        <v-chip 
                                          v-bind="props" 
                                          :color="(CRMLocality.offsetProductSale == 0 || CRMLocality.productSale == CRMLocality.offsetProductSale) ? 'primary' : CRMLocality.productSale > CRMLocality.offsetProductSale ? 'success' : 'error'" 
                                          variant="flat" 
                                          elevation="2" 
                                          label
                                          class="hoverableText"
                                        >
                                          <v-icon size="small" start>
                                            {{ (CRMLocality.offsetProductSale == 0 || CRMLocality.productSale == CRMLocality.offsetProductSale) ? 'mdi-trending-neutral' : CRMLocality.productSale > CRMLocality.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                          </v-icon>
                                          <template v-if="CRMLocality.productSale == 0 && CRMLocality.offsetProductSale == 0">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMLocality.productSale == 0 && CRMLocality.offsetProductSale > 0">
                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMLocality.offsetProductSale == 0 && CRMLocality.productSale > 0">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMLocality.productSale == CRMLocality.offsetProductSale">
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                          </template>
                                          <template v-else-if="CRMLocality.productSale > CRMLocality.offsetProductSale">
                                            <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productSale - CRMLocality.offsetProductSale) / CRMLocality.offsetProductSale) * 100)) }} %</strong></p>
                                          </template>
                                          <template v-else>
                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productSale - CRMLocality.offsetProductSale) / CRMLocality.offsetProductSale) * 100)) }} %</strong></p>
                                          </template>
                                        </v-chip>
                                      </template>
                                      <div>
                                        <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.productSale || 0) / 5) * 5) }}</p>
                                        <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.offsetProductSale || 0) / 5) * 5) }}</p>
                                        <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ CRMLocality.productSale > CRMLocality.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(CRMLocality.productSale - CRMLocality.offsetProductSale) || 0) / 5) * 5) }}</p>
                                      </div>
                                    </v-tooltip>
                                  </template>
                                </div>
                              </div>
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-menu>
                    <template v-if="input.show == 'productAmount'">
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-chip 
                            v-bind="props" 
                            :color="(productCategory.offsetProductAmount == 0 || productCategory.productAmount == productCategory.offsetProductAmount) ? 'primary' : productCategory.productAmount > productCategory.offsetProductAmount ? 'success' : 'error'" 
                            variant="flat" 
                            elevation="2" 
                            label
                            class="hoverableText"
                          >
                            <v-icon size="small" start>
                              {{ (productCategory.offsetProductAmount == 0 || productCategory.productAmount == productCategory.offsetProductAmount) ? 'mdi-trending-neutral' : productCategory.productAmount > productCategory.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                            </v-icon>
                            <template v-if="productCategory.productAmount == 0 && productCategory.offsetProductAmount == 0">
                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                            </template>
                            <template v-else-if="productCategory.productAmount == 0 && productCategory.offsetProductAmount > 0">
                              <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                            </template>
                            <template v-else-if="productCategory.offsetProductAmount == 0 && productCategory.productAmount > 0">
                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                            </template>
                            <template v-else-if="productCategory.productAmount == productCategory.offsetProductAmount">
                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                            </template>
                            <template v-else-if="productCategory.productAmount > productCategory.offsetProductAmount">
                              <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productCategory.productAmount - productCategory.offsetProductAmount) / productCategory.offsetProductAmount) * 100)) }} %</strong></p>
                            </template>
                            <template v-else>
                              <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productCategory.productAmount - productCategory.offsetProductAmount) / productCategory.offsetProductAmount) * 100)) }} %</strong></p>
                            </template>
                          </v-chip>
                        </template>
                        <div>
                          <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productCategory.productAmount) }}</p>
                          <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productCategory.offsetProductAmount) }}</p>
                          <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ productCategory.productAmount > productCategory.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(productCategory.productAmount - productCategory.offsetProductAmount)) }}</p>
                        </div>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-chip 
                            v-bind="props" 
                            :color="(productCategory.offsetProductSale == 0 || productCategory.productSale == productCategory.offsetProductSale) ? 'primary' : productCategory.productSale > productCategory.offsetProductSale ? 'success' : 'error'" 
                            variant="flat" 
                            elevation="2" 
                            label
                            class="hoverableText"
                          >
                            <v-icon size="small" start>
                              {{ (productCategory.offsetProductSale == 0 || productCategory.productSale == productCategory.offsetProductSale) ? 'mdi-trending-neutral' : productCategory.productSale > productCategory.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                            </v-icon>
                            <template v-if="productCategory.productSale == 0 && productCategory.offsetProductSale == 0">
                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                            </template>
                            <template v-else-if="productCategory.productSale == 0 && productCategory.offsetProductSale > 0">
                              <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                            </template>
                            <template v-else-if="productCategory.offsetProductSale == 0 && productCategory.productSale > 0">
                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                            </template>
                            <template v-else-if="productCategory.productSale == productCategory.offsetProductSale">
                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                            </template>
                            <template v-else-if="productCategory.productSale > productCategory.offsetProductSale">
                              <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productCategory.productSale - productCategory.offsetProductSale) / productCategory.offsetProductSale) * 100)) }} %</strong></p>
                            </template>
                            <template v-else>
                              <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productCategory.productSale - productCategory.offsetProductSale) / productCategory.offsetProductSale) * 100)) }} %</strong></p>
                            </template>
                          </v-chip>
                        </template>
                        <div>
                          <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productCategory.productSale || 0) / 5) * 5) }}</p>
                          <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productCategory.offsetProductSale || 0) / 5) * 5) }}</p>
                          <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ productCategory.productSale > productCategory.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(productCategory.productSale - productCategory.offsetProductSale) || 0) / 5) * 5) }}</p>
                        </div>
                      </v-tooltip>
                    </template>
                    <div style="width: 50px; height: 50px; text-align: center;">
                      <apexchart
                        type="donut"
                        :options="{chart: {type: 'donut', sparkline: {enabled: true} }, tooltip: {enabled: false}, plotOptions: {pie: {donut: {size: '50%', labels: {show: false}}}}, colors: ['#3F51B5', '#e0e0e0']}"
                        :series="[getProductCategoryPercentage(productCategory, true), 100 - getProductCategoryPercentage(productCategory, true)]"
                        height="50"
                        width="50"
                      ></apexchart>
                      <p style="font-size: x-small; color: #9e9e9e; margin-top: 5px;">{{ getProductCategoryPercentage(productCategory, false) }}%</p>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div style="display: flex; flex-direction: column; gap: 10px;">
                  <v-expansion-panels
                    v-for="productBrand in productCategory.productBrands.slice().sort((productBrandA, productBrandB) => productBrandB.productAmount - productBrandA.productAmount)"
                    :key="productBrand.productBrandID"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-title>
                        <div style="width: 100%; display: flex; align-items: center;">
                          <h3>{{ productBrand.productBrandName }}</h3>
                          <div style="display: flex; gap: 5px; margin-left: auto; margin-right: 10px; align-items: center;">
                            <template v-if="input.show == 'productAmount'">
                              <v-tooltip 
                                :disabled="systemInformationData.tooltipDisabled" 
                                :text="`Unidad${productBrand.productAmount == 1 ? '': 'es'} vendida${productBrand.productAmount == 1 ? '': 's'}`"
                                location="top"
                              >
                                <template v-slot:activator="{ props }">
                                  <v-chip 
                                    v-bind="props" 
                                    color="primary" 
                                    variant="flat"
                                    elevation="2"
                                    label 
                                    class="hoverableText"
                                  >
                                    <v-icon size="small" start>mdi-counter</v-icon>
                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productBrand.productAmount) }}</strong></p>
                                  </v-chip>
                                </template>
                              </v-tooltip>
                            </template>
                            <template v-else>
                              <v-tooltip 
                                :disabled="systemInformationData.tooltipDisabled" 
                                :text="`Monto de venta${productBrand.productSale == 1 ? '': 's'}`"
                                location="top"
                              >
                                <template v-slot:activator="{ props }">
                                  <v-chip 
                                    v-bind="props" 
                                    color="primary" 
                                    variant="flat" 
                                    elevation="2"
                                    label 
                                    class="hoverableText"
                                  >
                                    <v-icon size="small" start>mdi-cash</v-icon>
                                    <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((productBrand.productSale || 0) / 5) * 5) }}</strong></p>
                                  </v-chip>
                                </template>
                              </v-tooltip>
                            </template>
                            <v-menu 
                              :close-on-content-click="false" 
                              scrim 
                              @contextmenu.prevent="null"
                              style="cursor: default; user-select: none;">
                              <template v-slot:activator="{ props }">
                                <v-chip 
                                  v-bind="props" 
                                  color="primary" 
                                  variant="flat" 
                                  elevation="2" 
                                  label 
                                  class="hoverableText"
                                >
                                  <v-icon size="small">mdi-briefcase-account</v-icon>
                                </v-chip>
                              </template>
                              <v-list density="compact" style="padding: 0px 5px; margin: 0; max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                                <template 
                                  v-for="([CRMAgentID, CRMAgent]) in Object.entries(productBrand.byCRMAgent).sort((CRMAgentA, CRMAgentB) => input.show == 'productAmount' ? (input.sort == 'DESC' ? CRMAgentB[1].productAmount - CRMAgentA[1].productAmount : CRMAgentA[1].productAmount - CRMAgentB[1].productAmount) : (input.sort == 'DESC' ? CRMAgentB[1].productSale - CRMAgentA[1].productSale : CRMAgentA[1].productSale - CRMAgentB[1].productSale))" 
                                  v-bind:key="CRMAgentID"
                                >
                                  <v-list-item 
                                    @click.prevent="null"  
                                    class="hoverableText" 
                                    style="padding: 0; margin: 0; overflow-x: hidden;"
                                  >
                                    <v-list-item-title>
                                      <div style="display: flex; align-items: center; min-width: 400px; gap: 10px;">
                                        <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID)">
                                          <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentColor || 'primary'" elevation="2" variant="flat" label>
                                            <div style="display: flex; align-items: center;">
                                              <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                                              <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentName }}</p>
                                            </div>
                                          </v-chip>
                                        </template>
                                        <template v-else>
                                          <v-chip color="primary" elevation="2" variant="flat" label>
                                            <div style="display: flex; align-items: center;">
                                              <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                                              <p>No registrado</p>
                                            </div>
                                          </v-chip>
                                        </template>
                                        <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
                                          <template v-if="input.show == 'productAmount'">
                                            <v-tooltip 
                                              :disabled="systemInformationData.tooltipDisabled" 
                                              :text="`Unidad${CRMAgent.productAmount == 1 ? '': 'es'} vendida${CRMAgent.productAmount == 1 ? '': 's'}`" 
                                              location="top"
                                            >
                                              <template v-slot:activator="{ props }">
                                                <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                  <v-icon size="small" start>mdi-counter</v-icon>
                                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.productAmount) }}</strong></p>
                                                </v-chip>
                                              </template>
                                            </v-tooltip>
                                            <v-tooltip location="top">
                                              <template v-slot:activator="{ props }">
                                                <v-chip 
                                                  v-bind="props" 
                                                  :color="(CRMAgent.offsetProductAmount == 0 || CRMAgent.productAmount == CRMAgent.offsetProductAmount) ? 'primary' : CRMAgent.productAmount > CRMAgent.offsetProductAmount ? 'success' : 'error'" 
                                                  variant="flat" 
                                                  elevation="2" 
                                                  label
                                                  class="hoverableText"
                                                >
                                                  <v-icon size="small" start>
                                                    {{ (CRMAgent.offsetProductAmount == 0 || CRMAgent.productAmount == CRMAgent.offsetProductAmount) ? 'mdi-trending-neutral' : CRMAgent.productAmount > CRMAgent.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                  </v-icon>
                                                  <template v-if="CRMAgent.productAmount == 0 && CRMAgent.offsetProductAmount == 0">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMAgent.productAmount == 0 && CRMAgent.offsetProductAmount > 0">
                                                    <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMAgent.offsetProductAmount == 0 && CRMAgent.productAmount > 0">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMAgent.productAmount == CRMAgent.offsetProductAmount">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMAgent.productAmount > CRMAgent.offsetProductAmount">
                                                    <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productAmount - CRMAgent.offsetProductAmount) / CRMAgent.offsetProductAmount) * 100)) }} %</strong></p>
                                                  </template>
                                                  <template v-else>
                                                    <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productAmount - CRMAgent.offsetProductAmount) / CRMAgent.offsetProductAmount) * 100)) }} %</strong></p>
                                                  </template>
                                                </v-chip>
                                              </template>
                                              <div>
                                                <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.productAmount) }}</p>
                                                <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.offsetProductAmount) }}</p>
                                                <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ CRMAgent.productAmount > CRMAgent.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(CRMAgent.productAmount - CRMAgent.offsetProductAmount)) }}</p>
                                              </div>
                                            </v-tooltip>
                                          </template>
                                          <template v-else>
                                            <v-tooltip 
                                              :disabled="systemInformationData.tooltipDisabled" 
                                              :text="`Monto de venta${CRMAgent.productSale == 1 ? '': 's'}`" 
                                              location="top"
                                            >
                                              <template v-slot:activator="{ props }">
                                                <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                  <v-icon size="small" start>mdi-cash</v-icon>
                                                  <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.productSale || 0) / 5) * 5) }}</strong></p>
                                                </v-chip>
                                              </template>
                                            </v-tooltip>
                                            <v-tooltip location="top">
                                              <template v-slot:activator="{ props }">
                                                <v-chip 
                                                  v-bind="props" 
                                                  :color="(CRMAgent.offsetProductSale == 0 || CRMAgent.productSale == CRMAgent.offsetProductSale) ? 'primary' : CRMAgent.productSale > CRMAgent.offsetProductSale ? 'success' : 'error'" 
                                                  variant="flat" 
                                                  elevation="2" 
                                                  label
                                                  class="hoverableText"
                                                >
                                                  <v-icon size="small" start>
                                                    {{ (CRMAgent.offsetProductSale == 0 || CRMAgent.productSale == CRMAgent.offsetProductSale) ? 'mdi-trending-neutral' : CRMAgent.productSale > CRMAgent.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                  </v-icon>
                                                  <template v-if="CRMAgent.productSale == 0 && CRMAgent.offsetProductSale == 0">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMAgent.productSale == 0 && CRMAgent.offsetProductSale > 0">
                                                    <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMAgent.offsetProductSale == 0 && CRMAgent.productSale > 0">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMAgent.productSale == CRMAgent.offsetProductSale">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMAgent.productSale > CRMAgent.offsetProductSale">
                                                    <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productSale - CRMAgent.offsetProductSale) / CRMAgent.offsetProductSale) * 100)) }} %</strong></p>
                                                  </template>
                                                  <template v-else>
                                                    <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productSale - CRMAgent.offsetProductSale) / CRMAgent.offsetProductSale) * 100)) }} %</strong></p>
                                                  </template>
                                                </v-chip>
                                              </template>
                                              <div>
                                                <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.productSale || 0) / 5) * 5) }}</p>
                                                <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.offsetProductSale || 0) / 5) * 5) }}</p>
                                                <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ CRMAgent.productSale > CRMAgent.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(CRMAgent.productSale - CRMAgent.offsetProductSale) || 0) / 5) * 5) }}</p>
                                              </div>
                                            </v-tooltip>
                                          </template>
                                        </div>
                                      </div>
                                    </v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-list>
                            </v-menu>
                            <v-menu 
                              :close-on-content-click="false" 
                              scrim 
                              @contextmenu.prevent="null"
                              style="cursor: default; user-select: none;">
                              <template v-slot:activator="{ props }">
                                <v-chip 
                                  v-bind="props" 
                                  color="primary" 
                                  variant="flat" 
                                  elevation="2" 
                                  label 
                                  class="hoverableText"
                                >
                                  <v-icon size="small">mdi-store</v-icon>
                                </v-chip>
                              </template>
                              <v-list density="compact" style="padding: 0px 5px; margin: 0; max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                                <template 
                                  v-for="([CRMLocalityID, CRMLocality]) in Object.entries(productBrand.byCRMLocality).sort((CRMLocalityA, CRMLocalityB) => input.show == 'productAmount' ? (input.sort == 'DESC' ? CRMLocalityB[1].productAmount - CRMLocalityA[1].productAmount : CRMLocalityA[1].productAmount - CRMLocalityB[1].productAmount) : (input.sort == 'DESC' ? CRMLocalityB[1].productSale - CRMLocalityA[1].productSale : CRMLocalityA[1].productSale - CRMLocalityB[1].productSale))" 
                                  v-bind:key="CRMLocalityID"
                                >
                                  <v-list-item 
                                    @click.prevent="null"  
                                    class="hoverableText" 
                                    style="padding: 0; margin: 0; overflow-x: hidden;"
                                  >
                                    <v-list-item-title>
                                      <div style="display: flex; align-items: center; min-width: 400px; gap: 10px;">
                                        <template v-if="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID)">
                                          <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID).CRMLocalityColor || 'primary'" elevation="2" variant="flat" label>
                                            <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID).CRMLocalityName }}</p>
                                          </v-chip>
                                        </template>
                                        <template v-else>
                                          <v-chip color="primary" elevation="2" variant="flat" label>
                                            <p>No registrada</p>
                                          </v-chip>
                                        </template>
                                        <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
                                          <template v-if="input.show == 'productAmount'">
                                            <v-tooltip 
                                              :disabled="systemInformationData.tooltipDisabled" 
                                              :text="`Unidad${CRMLocality.productAmount == 1 ? '': 'es'} vendida${CRMLocality.productAmount == 1 ? '': 's'}`" 
                                              location="top"
                                            >
                                              <template v-slot:activator="{ props }">
                                                <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                  <v-icon size="small" start>mdi-counter</v-icon>
                                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.productAmount) }}</strong></p>
                                                </v-chip>
                                              </template>
                                            </v-tooltip>
                                            <v-tooltip location="top">
                                              <template v-slot:activator="{ props }">
                                                <v-chip 
                                                  v-bind="props" 
                                                  :color="(CRMLocality.offsetProductAmount == 0 || CRMLocality.productAmount == CRMLocality.offsetProductAmount) ? 'primary' : CRMLocality.productAmount > CRMLocality.offsetProductAmount ? 'success' : 'error'" 
                                                  variant="flat" 
                                                  elevation="2" 
                                                  label
                                                  class="hoverableText"
                                                >
                                                  <v-icon size="small" start>
                                                    {{ (CRMLocality.offsetProductAmount == 0 || CRMLocality.productAmount == CRMLocality.offsetProductAmount) ? 'mdi-trending-neutral' : CRMLocality.productAmount > CRMLocality.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                  </v-icon>
                                                  <template v-if="CRMLocality.productAmount == 0 && CRMLocality.offsetProductAmount == 0">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMLocality.productAmount == 0 && CRMLocality.offsetProductAmount > 0">
                                                    <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMLocality.offsetProductAmount == 0 && CRMLocality.productAmount > 0">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMLocality.productAmount == CRMLocality.offsetProductAmount">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMLocality.productAmount > CRMLocality.offsetProductAmount">
                                                    <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productAmount - CRMLocality.offsetProductAmount) / CRMLocality.offsetProductAmount) * 100)) }} %</strong></p>
                                                  </template>
                                                  <template v-else>
                                                    <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productAmount - CRMLocality.offsetProductAmount) / CRMLocality.offsetProductAmount) * 100)) }} %</strong></p>
                                                  </template>
                                                </v-chip>
                                              </template>
                                              <div>
                                                <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.productAmount) }}</p>
                                                <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.offsetProductAmount) }}</p>
                                                <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ CRMLocality.productAmount > CRMLocality.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(CRMLocality.productAmount - CRMLocality.offsetProductAmount)) }}</p>
                                              </div>
                                            </v-tooltip>
                                          </template>
                                          <template v-else>
                                            <v-tooltip 
                                              :disabled="systemInformationData.tooltipDisabled" 
                                              :text="`Monto de venta${CRMLocality.productSale == 1 ? '': 's'}`" 
                                              location="top"
                                            >
                                              <template v-slot:activator="{ props }">
                                                <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                  <v-icon size="small" start>mdi-cash</v-icon>
                                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.productSale || 0) / 5) * 5) }}</strong></p>
                                                </v-chip>
                                              </template>
                                            </v-tooltip>
                                            <v-tooltip location="top">
                                              <template v-slot:activator="{ props }">
                                                <v-chip 
                                                  v-bind="props" 
                                                  :color="(CRMLocality.offsetProductSale == 0 || CRMLocality.productSale == CRMLocality.offsetProductSale) ? 'primary' : CRMLocality.productSale > CRMLocality.offsetProductSale ? 'success' : 'error'" 
                                                  variant="flat" 
                                                  elevation="2" 
                                                  label
                                                  class="hoverableText"
                                                >
                                                  <v-icon size="small" start>
                                                    {{ (CRMLocality.offsetProductSale == 0 || CRMLocality.productSale == CRMLocality.offsetProductSale) ? 'mdi-trending-neutral' : CRMLocality.productSale > CRMLocality.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                  </v-icon>
                                                  <template v-if="CRMLocality.productSale == 0 && CRMLocality.offsetProductSale == 0">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMLocality.productSale == 0 && CRMLocality.offsetProductSale > 0">
                                                    <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMLocality.offsetProductSale == 0 && CRMLocality.productSale > 0">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMLocality.productSale == CRMLocality.offsetProductSale">
                                                    <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                  </template>
                                                  <template v-else-if="CRMLocality.productSale > CRMLocality.offsetProductSale">
                                                    <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productSale - CRMLocality.offsetProductSale) / CRMLocality.offsetProductSale) * 100)) }} %</strong></p>
                                                  </template>
                                                  <template v-else>
                                                    <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productSale - CRMLocality.offsetProductSale) / CRMLocality.offsetProductSale) * 100)) }} %</strong></p>
                                                  </template>
                                                </v-chip>
                                              </template>
                                              <div>
                                                <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.productSale || 0) / 5) * 5) }}</p>
                                                <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.offsetProductSale || 0) / 5) * 5) }}</p>
                                                <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ CRMLocality.productSale > CRMLocality.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(CRMLocality.productSale - CRMLocality.offsetProductSale) || 0) / 5) * 5) }}</p>
                                              </div>
                                            </v-tooltip>
                                          </template>
                                        </div>
                                      </div>
                                    </v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-list>
                            </v-menu>
                            <template v-if="input.show == 'productAmount'">
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-chip 
                                    v-bind="props" 
                                    :color="(productBrand.offsetProductAmount == 0 || productBrand.productAmount == productBrand.offsetProductAmount) ? 'primary' : productBrand.productAmount > productBrand.offsetProductAmount ? 'success' : 'error'" 
                                    variant="flat" 
                                    elevation="2" 
                                    label
                                    class="hoverableText"
                                  >
                                    <v-icon size="small" start>
                                      {{ (productBrand.offsetProductAmount == 0 || productBrand.productAmount == productBrand.offsetProductAmount) ? 'mdi-trending-neutral' : productBrand.productAmount > productBrand.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                    </v-icon>
                                    <template v-if="productBrand.productAmount == 0 && productBrand.offsetProductAmount == 0">
                                      <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                    </template>
                                    <template v-else-if="productBrand.productAmount == 0 && productBrand.offsetProductAmount > 0">
                                      <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                    </template>
                                    <template v-else-if="productBrand.offsetProductAmount == 0 && productBrand.productAmount > 0">
                                      <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                    </template>
                                    <template v-else-if="productBrand.productAmount == productBrand.offsetProductAmount">
                                      <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                    </template>
                                    <template v-else-if="productBrand.productAmount > productBrand.offsetProductAmount">
                                      <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productBrand.productAmount - productBrand.offsetProductAmount) / productBrand.offsetProductAmount) * 100)) }} %</strong></p>
                                    </template>
                                    <template v-else>
                                      <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productBrand.productAmount - productBrand.offsetProductAmount) / productBrand.offsetProductAmount) * 100)) }} %</strong></p>
                                    </template>
                                  </v-chip>
                                </template>
                                <div>
                                  <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productBrand.productAmount) }}</p>
                                  <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productBrand.offsetProductAmount) }}</p>
                                  <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ productBrand.productAmount > productBrand.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(productBrand.productAmount - productBrand.offsetProductAmount)) }}</p>
                                </div>
                              </v-tooltip>
                            </template>
                            <template v-else>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-chip 
                                    v-bind="props" 
                                    :color="(productBrand.offsetProductSale == 0 || productBrand.productSale == productBrand.offsetProductSale) ? 'primary' : productBrand.productSale > productBrand.offsetProductSale ? 'success' : 'error'" 
                                    variant="flat" 
                                    elevation="2" 
                                    label
                                    class="hoverableText"
                                  >
                                    <v-icon size="small" start>
                                      {{ (productBrand.offsetProductSale == 0 || productBrand.productSale == productBrand.offsetProductSale) ? 'mdi-trending-neutral' : productBrand.productSale > productBrand.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                    </v-icon>
                                    <template v-if="productBrand.productSale == 0 && productBrand.offsetProductSale == 0">
                                      <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                    </template>
                                    <template v-else-if="productBrand.productSale == 0 && productBrand.offsetProductSale > 0">
                                      <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                    </template>
                                    <template v-else-if="productBrand.offsetProductSale == 0 && productBrand.productSale > 0">
                                      <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                    </template>
                                    <template v-else-if="productBrand.productSale == productBrand.offsetProductSale">
                                      <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                    </template>
                                    <template v-else-if="productBrand.productSale > productBrand.offsetProductSale">
                                      <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productBrand.productSale - productBrand.offsetProductSale) / productBrand.offsetProductSale) * 100)) }} %</strong></p>
                                    </template>
                                    <template v-else>
                                      <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productBrand.productSale - productBrand.offsetProductSale) / productBrand.offsetProductSale) * 100)) }} %</strong></p>
                                    </template>
                                  </v-chip>
                                </template>
                                <div>
                                  <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productBrand.productSale || 0) / 5) * 5) }}</p>
                                  <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productBrand.offsetProductSale || 0) / 5) * 5) }}</p>
                                  <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ productBrand.productSale > productBrand.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(productBrand.productSale - productBrand.offsetProductSale) || 0) / 5) * 5) }}</p>
                                </div>
                              </v-tooltip>
                            </template>
                            <div style="width: 50px; height: 50px; text-align: center;">
                              <apexchart
                                type="donut"
                                :options="{chart: {type: 'donut', sparkline: {enabled: true} }, tooltip: {enabled: false}, plotOptions: {pie: {donut: {size: '50%', labels: {show: false}}}}, colors: ['#3F51B5', '#e0e0e0']}"
                                :series="[getProductBrandPercentage(productCategory, productBrand.productBrandID, true), 100 - getProductBrandPercentage(productCategory, productBrand.productBrandID, true)]"
                                height="50"
                                width="50"
                              ></apexchart>
                              <p style="font-size: x-small; color: #9e9e9e; margin-top: 5px;">{{ getProductBrandPercentage(productCategory, productBrand.productBrandID, false) }}%</p>
                            </div>
                          </div>
                        </div>
                      </v-expansion-panel-title>
                      <v-expansion-panel-text>
                        <div style="display: flex; flex-direction: column; gap: 10px;">
                          <v-expansion-panels
                            v-for="productModel in productBrand.productModels.slice().sort((productModelA, productModelB) => productModelB.productAmount - productModelA.productAmount)"
                            :key="productModel.productModelID"
                          >
                            <v-expansion-panel>
                              <v-expansion-panel-title>
                                <div style="width: 100%; display: flex; align-items: center;">
                                  <h4>{{ productModel.productModelName }}</h4>
                                  <div style="display: flex; gap: 5px; margin-left: auto; margin-right: 10px; align-items: center;">
                                    <template v-if="input.show == 'productAmount'">
                                      <v-tooltip 
                                        :disabled="systemInformationData.tooltipDisabled" 
                                        :text="`Unidad${productModel.productAmount == 1 ? '': 'es'} vendida${productModel.productAmount == 1 ? '': 's'}`"
                                        location="top"
                                      >
                                        <template v-slot:activator="{ props }">
                                          <v-chip 
                                            v-bind="props" 
                                            color="primary" 
                                            variant="flat"
                                            elevation="2"
                                            label 
                                            class="hoverableText"
                                          >
                                            <v-icon size="small" start>mdi-counter</v-icon>
                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productModel.productAmount) }}</strong></p>
                                          </v-chip>
                                        </template>
                                      </v-tooltip>
                                    </template>
                                    <template v-else>
                                      <v-tooltip 
                                        :disabled="systemInformationData.tooltipDisabled" 
                                        :text="`Monto de venta${productModel.productSale == 1 ? '': 's'}`"
                                        location="top"
                                      >
                                        <template v-slot:activator="{ props }">
                                          <v-chip 
                                            v-bind="props" 
                                            color="primary" 
                                            variant="flat" 
                                            elevation="2"
                                            label 
                                            class="hoverableText"
                                          >
                                            <v-icon size="small" start>mdi-cash</v-icon>
                                            <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((productModel.productSale || 0) / 5) * 5) }}</strong></p>
                                          </v-chip>
                                        </template>
                                      </v-tooltip>
                                    </template>
                                    <v-menu 
                                      :close-on-content-click="false" 
                                      scrim 
                                      @contextmenu.prevent="null"
                                      style="cursor: default; user-select: none;">
                                      <template v-slot:activator="{ props }">
                                        <v-chip 
                                          v-bind="props" 
                                          color="primary" 
                                          variant="flat" 
                                          elevation="2" 
                                          label 
                                          class="hoverableText"
                                        >
                                          <v-icon size="small">mdi-briefcase-account</v-icon>
                                        </v-chip>
                                      </template>
                                      <v-list density="compact" style="padding: 0px 5px; margin: 0; max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                                        <template 
                                          v-for="([CRMAgentID, CRMAgent]) in Object.entries(productModel.byCRMAgent).sort((CRMAgentA, CRMAgentB) => input.show == 'productAmount' ? (input.sort == 'DESC' ? CRMAgentB[1].productAmount - CRMAgentA[1].productAmount : CRMAgentA[1].productAmount - CRMAgentB[1].productAmount) : (input.sort == 'DESC' ? CRMAgentB[1].productSale - CRMAgentA[1].productSale : CRMAgentA[1].productSale - CRMAgentB[1].productSale))" 
                                          v-bind:key="CRMAgentID"
                                        >
                                          <v-list-item 
                                            @click.prevent="null"  
                                            class="hoverableText" 
                                            style="padding: 0; margin: 0; overflow-x: hidden;"
                                          >
                                            <v-list-item-title>
                                              <div style="display: flex; align-items: center; min-width: 400px; gap: 10px;">
                                                <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID)">
                                                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentColor || 'primary'" elevation="2" variant="flat" label>
                                                    <div style="display: flex; align-items: center;">
                                                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                                                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentName }}</p>
                                                    </div>
                                                  </v-chip>
                                                </template>
                                                <template v-else>
                                                  <v-chip color="primary" elevation="2" variant="flat" label>
                                                    <div style="display: flex; align-items: center;">
                                                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                                                      <p>No registrado</p>
                                                    </div>
                                                  </v-chip>
                                                </template>
                                                <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
                                                  <template v-if="input.show == 'productAmount'">
                                                    <v-tooltip 
                                                      :disabled="systemInformationData.tooltipDisabled" 
                                                      :text="`Unidad${CRMAgent.productAmount == 1 ? '': 'es'} vendida${CRMAgent.productAmount == 1 ? '': 's'}`" 
                                                      location="top"
                                                    >
                                                      <template v-slot:activator="{ props }">
                                                        <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                          <v-icon size="small" start>mdi-counter</v-icon>
                                                          <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.productAmount) }}</strong></p>
                                                        </v-chip>
                                                      </template>
                                                    </v-tooltip>
                                                    <v-tooltip location="top">
                                                      <template v-slot:activator="{ props }">
                                                        <v-chip 
                                                          v-bind="props" 
                                                          :color="(CRMAgent.offsetProductAmount == 0 || CRMAgent.productAmount == CRMAgent.offsetProductAmount) ? 'primary' : CRMAgent.productAmount > CRMAgent.offsetProductAmount ? 'success' : 'error'" 
                                                          variant="flat" 
                                                          elevation="2" 
                                                          label
                                                          class="hoverableText"
                                                        >
                                                          <v-icon size="small" start>
                                                            {{ (CRMAgent.offsetProductAmount == 0 || CRMAgent.productAmount == CRMAgent.offsetProductAmount) ? 'mdi-trending-neutral' : CRMAgent.productAmount > CRMAgent.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                          </v-icon>
                                                          <template v-if="CRMAgent.productAmount == 0 && CRMAgent.offsetProductAmount == 0">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMAgent.productAmount == 0 && CRMAgent.offsetProductAmount > 0">
                                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMAgent.offsetProductAmount == 0 && CRMAgent.productAmount > 0">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMAgent.productAmount == CRMAgent.offsetProductAmount">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMAgent.productAmount > CRMAgent.offsetProductAmount">
                                                            <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productAmount - CRMAgent.offsetProductAmount) / CRMAgent.offsetProductAmount) * 100)) }} %</strong></p>
                                                          </template>
                                                          <template v-else>
                                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productAmount - CRMAgent.offsetProductAmount) / CRMAgent.offsetProductAmount) * 100)) }} %</strong></p>
                                                          </template>
                                                        </v-chip>
                                                      </template>
                                                      <div>
                                                        <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.productAmount) }}</p>
                                                        <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.offsetProductAmount) }}</p>
                                                        <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ CRMAgent.productAmount > CRMAgent.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(CRMAgent.productAmount - CRMAgent.offsetProductAmount)) }}</p>
                                                      </div>
                                                    </v-tooltip>
                                                  </template>
                                                  <template v-else>
                                                    <v-tooltip 
                                                      :disabled="systemInformationData.tooltipDisabled" 
                                                      :text="`Monto de venta${CRMAgent.productSale == 1 ? '': 's'}`" 
                                                      location="top"
                                                    >
                                                      <template v-slot:activator="{ props }">
                                                        <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                          <v-icon size="small" start>mdi-cash</v-icon>
                                                          <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.productSale || 0) / 5) * 5) }}</strong></p>
                                                        </v-chip>
                                                      </template>
                                                    </v-tooltip>
                                                    <v-tooltip location="top">
                                                      <template v-slot:activator="{ props }">
                                                        <v-chip 
                                                          v-bind="props" 
                                                          :color="(CRMAgent.offsetProductSale == 0 || CRMAgent.productSale == CRMAgent.offsetProductSale) ? 'primary' : CRMAgent.productSale > CRMAgent.offsetProductSale ? 'success' : 'error'" 
                                                          variant="flat" 
                                                          elevation="2" 
                                                          label
                                                          class="hoverableText"
                                                        >
                                                          <v-icon size="small" start>
                                                            {{ (CRMAgent.offsetProductSale == 0 || CRMAgent.productSale == CRMAgent.offsetProductSale) ? 'mdi-trending-neutral' : CRMAgent.productSale > CRMAgent.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                          </v-icon>
                                                          <template v-if="CRMAgent.productSale == 0 && CRMAgent.offsetProductSale == 0">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMAgent.productSale == 0 && CRMAgent.offsetProductSale > 0">
                                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMAgent.offsetProductSale == 0 && CRMAgent.productSale > 0">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMAgent.productSale == CRMAgent.offsetProductSale">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMAgent.productSale > CRMAgent.offsetProductSale">
                                                            <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productSale - CRMAgent.offsetProductSale) / CRMAgent.offsetProductSale) * 100)) }} %</strong></p>
                                                          </template>
                                                          <template v-else>
                                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productSale - CRMAgent.offsetProductSale) / CRMAgent.offsetProductSale) * 100)) }} %</strong></p>
                                                          </template>
                                                        </v-chip>
                                                      </template>
                                                      <div>
                                                        <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.productSale || 0) / 5) * 5) }}</p>
                                                        <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.offsetProductSale || 0) / 5) * 5) }}</p>
                                                        <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ CRMAgent.productSale > CRMAgent.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(CRMAgent.productSale - CRMAgent.offsetProductSale) || 0) / 5) * 5) }}</p>
                                                      </div>
                                                    </v-tooltip>
                                                  </template>
                                                </div>
                                              </div>
                                            </v-list-item-title>
                                          </v-list-item>
                                        </template>
                                      </v-list>
                                    </v-menu>
                                    <v-menu 
                                      :close-on-content-click="false" 
                                      scrim 
                                      @contextmenu.prevent="null"
                                      style="cursor: default; user-select: none;">
                                      <template v-slot:activator="{ props }">
                                        <v-chip 
                                          v-bind="props" 
                                          color="primary" 
                                          variant="flat" 
                                          elevation="2" 
                                          label 
                                          class="hoverableText"
                                        >
                                          <v-icon size="small">mdi-store</v-icon>
                                        </v-chip>
                                      </template>
                                      <v-list density="compact" style="padding: 0px 5px; margin: 0; max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                                        <template 
                                          v-for="([CRMLocalityID, CRMLocality]) in Object.entries(productModel.byCRMLocality).sort((CRMLocalityA, CRMLocalityB) => input.show == 'productAmount' ? (input.sort == 'DESC' ? CRMLocalityB[1].productAmount - CRMLocalityA[1].productAmount : CRMLocalityA[1].productAmount - CRMLocalityB[1].productAmount) : (input.sort == 'DESC' ? CRMLocalityB[1].productSale - CRMLocalityA[1].productSale : CRMLocalityA[1].productSale - CRMLocalityB[1].productSale))" 
                                          v-bind:key="CRMLocalityID"
                                        >
                                          <v-list-item 
                                            @click.prevent="null"  
                                            class="hoverableText" 
                                            style="padding: 0; margin: 0; overflow-x: hidden;"
                                          >
                                            <v-list-item-title>
                                              <div style="display: flex; align-items: center; min-width: 400px; gap: 10px;">
                                                <template v-if="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID)">
                                                  <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID).CRMLocalityColor || 'primary'" elevation="2" variant="flat" label>
                                                    <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID).CRMLocalityName }}</p>
                                                  </v-chip>
                                                </template>
                                                <template v-else>
                                                  <v-chip color="primary" elevation="2" variant="flat" label>
                                                    <p>No registrada</p>
                                                  </v-chip>
                                                </template>
                                                <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
                                                  <template v-if="input.show == 'productAmount'">
                                                    <v-tooltip 
                                                      :disabled="systemInformationData.tooltipDisabled" 
                                                      :text="`Unidad${CRMLocality.productAmount == 1 ? '': 'es'} vendida${CRMLocality.productAmount == 1 ? '': 's'}`" 
                                                      location="top"
                                                    >
                                                      <template v-slot:activator="{ props }">
                                                        <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                          <v-icon size="small" start>mdi-counter</v-icon>
                                                          <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.productAmount) }}</strong></p>
                                                        </v-chip>
                                                      </template>
                                                    </v-tooltip>
                                                    <v-tooltip location="top">
                                                      <template v-slot:activator="{ props }">
                                                        <v-chip 
                                                          v-bind="props" 
                                                          :color="(CRMLocality.offsetProductAmount == 0 || CRMLocality.productAmount == CRMLocality.offsetProductAmount) ? 'primary' : CRMLocality.productAmount > CRMLocality.offsetProductAmount ? 'success' : 'error'" 
                                                          variant="flat" 
                                                          elevation="2" 
                                                          label
                                                          class="hoverableText"
                                                        >
                                                          <v-icon size="small" start>
                                                            {{ (CRMLocality.offsetProductAmount == 0 || CRMLocality.productAmount == CRMLocality.offsetProductAmount) ? 'mdi-trending-neutral' : CRMLocality.productAmount > CRMLocality.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                          </v-icon>
                                                          <template v-if="CRMLocality.productAmount == 0 && CRMLocality.offsetProductAmount == 0">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMLocality.productAmount == 0 && CRMLocality.offsetProductAmount > 0">
                                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMLocality.offsetProductAmount == 0 && CRMLocality.productAmount > 0">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMLocality.productAmount == CRMLocality.offsetProductAmount">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMLocality.productAmount > CRMLocality.offsetProductAmount">
                                                            <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productAmount - CRMLocality.offsetProductAmount) / CRMLocality.offsetProductAmount) * 100)) }} %</strong></p>
                                                          </template>
                                                          <template v-else>
                                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productAmount - CRMLocality.offsetProductAmount) / CRMLocality.offsetProductAmount) * 100)) }} %</strong></p>
                                                          </template>
                                                        </v-chip>
                                                      </template>
                                                      <div>
                                                        <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.productAmount) }}</p>
                                                        <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.offsetProductAmount) }}</p>
                                                        <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ CRMLocality.productAmount > CRMLocality.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(CRMLocality.productAmount - CRMLocality.offsetProductAmount)) }}</p>
                                                      </div>
                                                    </v-tooltip>
                                                  </template>
                                                  <template v-else>
                                                    <v-tooltip 
                                                      :disabled="systemInformationData.tooltipDisabled" 
                                                      :text="`Monto de venta${CRMLocality.productSale == 1 ? '': 's'}`" 
                                                      location="top"
                                                    >
                                                      <template v-slot:activator="{ props }">
                                                        <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                          <v-icon size="small" start>mdi-cash</v-icon>
                                                          <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.productSale || 0) / 5) * 5) }}</strong></p>
                                                        </v-chip>
                                                      </template>
                                                    </v-tooltip>
                                                    <v-tooltip location="top">
                                                      <template v-slot:activator="{ props }">
                                                        <v-chip 
                                                          v-bind="props" 
                                                          :color="(CRMLocality.offsetProductSale == 0 || CRMLocality.productSale == CRMLocality.offsetProductSale) ? 'primary' : CRMLocality.productSale > CRMLocality.offsetProductSale ? 'success' : 'error'" 
                                                          variant="flat" 
                                                          elevation="2" 
                                                          label
                                                          class="hoverableText"
                                                        >
                                                          <v-icon size="small" start>
                                                            {{ (CRMLocality.offsetProductSale == 0 || CRMLocality.productSale == CRMLocality.offsetProductSale) ? 'mdi-trending-neutral' : CRMLocality.productSale > CRMLocality.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                          </v-icon>
                                                          <template v-if="CRMLocality.productSale == 0 && CRMLocality.offsetProductSale == 0">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMLocality.productSale == 0 && CRMLocality.offsetProductSale > 0">
                                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMLocality.offsetProductSale == 0 && CRMLocality.productSale > 0">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMLocality.productSale == CRMLocality.offsetProductSale">
                                                            <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                          </template>
                                                          <template v-else-if="CRMLocality.productSale > CRMLocality.offsetProductSale">
                                                            <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productSale - CRMLocality.offsetProductSale) / CRMLocality.offsetProductSale) * 100)) }} %</strong></p>
                                                          </template>
                                                          <template v-else>
                                                            <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productSale - CRMLocality.offsetProductSale) / CRMLocality.offsetProductSale) * 100)) }} %</strong></p>
                                                          </template>
                                                        </v-chip>
                                                      </template>
                                                      <div>
                                                        <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.productSale || 0) / 5) * 5) }}</p>
                                                        <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.offsetProductSale || 0) / 5) * 5) }}</p>
                                                        <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ CRMLocality.productSale > CRMLocality.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(CRMLocality.productSale - CRMLocality.offsetProductSale) || 0) / 5) * 5) }}</p>
                                                      </div>
                                                    </v-tooltip>
                                                  </template>
                                                </div>
                                              </div>
                                            </v-list-item-title>
                                          </v-list-item>
                                        </template>
                                      </v-list>
                                    </v-menu>
                                    <template v-if="input.show == 'productAmount'">
                                      <v-tooltip location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-chip 
                                            v-bind="props" 
                                            :color="(productModel.offsetProductAmount == 0 || productModel.productAmount == productModel.offsetProductAmount) ? 'primary' : productModel.productAmount > productModel.offsetProductAmount ? 'success' : 'error'" 
                                            variant="flat" 
                                            elevation="2" 
                                            label
                                            class="hoverableText"
                                          >
                                            <v-icon size="small" start>
                                              {{ (productModel.offsetProductAmount == 0 || productModel.productAmount == productModel.offsetProductAmount) ? 'mdi-trending-neutral' : productModel.productAmount > productModel.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                            </v-icon>
                                            <template v-if="productModel.productAmount == 0 && productModel.offsetProductAmount == 0">
                                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                            </template>
                                            <template v-else-if="productModel.productAmount == 0 && productModel.offsetProductAmount > 0">
                                              <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                            </template>
                                            <template v-else-if="productModel.offsetProductAmount == 0 && productModel.productAmount > 0">
                                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                            </template>
                                            <template v-else-if="productModel.productAmount == productModel.offsetProductAmount">
                                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                            </template>
                                            <template v-else-if="productModel.productAmount > productModel.offsetProductAmount">
                                              <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productModel.productAmount - productModel.offsetProductAmount) / productModel.offsetProductAmount) * 100)) }} %</strong></p>
                                            </template>
                                            <template v-else>
                                              <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productBrand.productAmount - productBrand.offsetProductAmount) / productBrand.offsetProductAmount) * 100)) }} %</strong></p>
                                            </template>
                                          </v-chip>
                                        </template>
                                        <div>
                                          <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productModel.productAmount) }}</p>
                                          <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(productModel.offsetProductAmount) }}</p>
                                          <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ productModel.productAmount > productModel.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(productModel.productAmount - productModel.offsetProductAmount)) }}</p>
                                        </div>
                                      </v-tooltip>
                                    </template>
                                    <template v-else>
                                      <v-tooltip location="top">
                                        <template v-slot:activator="{ props }">
                                          <v-chip 
                                            v-bind="props" 
                                            :color="(productModel.offsetProductSale == 0 || productModel.productSale == productModel.offsetProductSale) ? 'primary' : productModel.productSale > productModel.offsetProductSale ? 'success' : 'error'" 
                                            variant="flat" 
                                            elevation="2" 
                                            label
                                            class="hoverableText"
                                          >
                                            <v-icon size="small" start>
                                              {{ (productModel.offsetProductSale == 0 || productModel.productSale == productModel.offsetProductSale) ? 'mdi-trending-neutral' : productModel.productSale > productModel.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                            </v-icon>
                                            <template v-if="productModel.productSale == 0 && productModel.offsetProductSale == 0">
                                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                            </template>
                                            <template v-else-if="productModel.productSale == 0 && productModel.offsetProductSale > 0">
                                              <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                            </template>
                                            <template v-else-if="productModel.offsetProductSale == 0 && productModel.productSale > 0">
                                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                            </template>
                                            <template v-else-if="productModel.productSale == productModel.offsetProductSale">
                                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                            </template>
                                            <template v-else-if="productModel.productSale > productModel.offsetProductSale">
                                              <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productModel.productSale - productModel.offsetProductSale) / productModel.offsetProductSale) * 100)) }} %</strong></p>
                                            </template>
                                            <template v-else>
                                              <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((productModel.productSale - productModel.offsetProductSale) / productModel.offsetProductSale) * 100)) }} %</strong></p>
                                            </template>
                                          </v-chip>
                                        </template>
                                        <div>
                                          <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productModel.productSale || 0) / 5) * 5) }}</p>
                                          <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((productModel.offsetProductSale || 0) / 5) * 5) }}</p>
                                          <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ productModel.productSale > productModel.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(productModel.productSale - productModel.offsetProductSale) || 0) / 5) * 5) }}</p>
                                        </div>
                                      </v-tooltip>
                                    </template>
                                    <div style="width: 50px; height: 50px; text-align: center;">
                                      <apexchart
                                        type="donut"
                                        :options="{chart: {type: 'donut', sparkline: {enabled: true} }, tooltip: {enabled: false}, plotOptions: {pie: {donut: {size: '50%', labels: {show: false}}}}, colors: ['#3F51B5', '#e0e0e0']}"
                                        :series="[getProductModelPercentage(productCategory, productBrand.productBrandID, productModel.productModelID, true), 100 - getProductModelPercentage(productCategory, productBrand.productBrandID, productModel.productModelID, true)]"
                                        height="50"
                                        width="50"
                                      ></apexchart>
                                      <p style="font-size: x-small; color: #9e9e9e; margin-top: 5px;">{{ getProductModelPercentage(productCategory, productBrand.productBrandID, productModel.productModelID, false) }}%</p>
                                    </div>
                                  </div>
                                </div>
                              </v-expansion-panel-title>
                              <v-expansion-panel-text>
                                <v-list density="compact" style="max-height: 500px; overflow-y: auto; scrollbar-width: thin; user-select: none;">
                                  <v-list-item 
                                    v-for="product in productModel.products.slice().sort((productA, productB) => productB.productAmount - productA.productAmount)"
                                    :key="product.productID"
                                    @click.prevent="null"
                                    density="compact"
                                    style="margin: 0"
                                  >
                                    <v-list-item-title style="display: flex; gap: 5px; align-items: center;">
                                      <div style="display: flex; align-items: center; margin-left: 15px;">
                                        <v-tooltip 
                                          :disabled="systemInformationData.tooltipDisabled" 
                                          :text="`Ranking del producto`" 
                                          location="top"
                                        >
                                          <template v-slot:activator="{ props }">
                                            <v-chip
                                              v-bind="props"
                                              color="indigo"
                                              variant="flat"
                                              elevation="2"
                                              label
                                              class="hoverableText"
                                              style="margin-right: 10px;"
                                            >
                                              <v-icon size="small" start>mdi-medal</v-icon>
                                              <p style="font-size: small;"><strong>{{ computed_sortedProduct.findIndex(p => p.productID == product.productID) + 1 }}</strong></p>
                                            </v-chip>
                                          </template>
                                        </v-tooltip>
                                        <img 
                                          @click="$root.dialogComponent.openMediaDialog(product.productImageURL, product.productName, 'webp')" 
                                          :src="product.productImageURL || require('@/assets/images/ProductPicturePlaceholder.png')" 
                                          draggable="false" 
                                          class="hoverableElement" 
                                          style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; border: 2px solid #3F51B5;"
                                        >
                                        <div style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start; margin-left: 10px;">
                                          <p>{{ product.productName }}</p>
                                          <p style="font-size: x-small; color: #9e9e9e;"><strong>{{ product.productID }}</strong></p>
                                        </div>
                                      </div>
                                      <div style="display: flex; gap: 5px; margin-left: auto;">
                                        <template v-if="input.show == 'productAmount'">
                                          <v-tooltip 
                                            :disabled="systemInformationData.tooltipDisabled" 
                                            :text="`Unidad${product.productAmount == 1 ? '': 'es'} vendida${product.productAmount == 1 ? '': 's'}`"
                                            location="top"
                                          >
                                            <template v-slot:activator="{ props }">
                                              <v-chip 
                                                v-bind="props" 
                                                color="primary" 
                                                variant="flat"
                                                elevation="2"
                                                label 
                                                class="hoverableText"
                                              >
                                                <v-icon size="small" start>mdi-counter</v-icon>
                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(product.productAmount) }}</strong></p>
                                              </v-chip>
                                            </template>
                                          </v-tooltip>
                                        </template>
                                        <template v-else>
                                          <v-tooltip 
                                            :disabled="systemInformationData.tooltipDisabled" 
                                            :text="`Monto de venta${product.productSale == 1 ? '': 's'}`"
                                            location="top"
                                          >
                                            <template v-slot:activator="{ props }">
                                              <v-chip 
                                                v-bind="props" 
                                                color="primary" 
                                                variant="flat" 
                                                elevation="2"
                                                label 
                                                class="hoverableText"
                                              >
                                                <v-icon size="small" start>mdi-cash</v-icon>
                                                <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((product.productSale || 0) / 5) * 5) }}</strong></p>
                                              </v-chip>
                                            </template>
                                          </v-tooltip>
                                        </template>
                                        <v-menu 
                                          :close-on-content-click="false" 
                                          scrim 
                                          @contextmenu.prevent="null"
                                          style="cursor: default; user-select: none;">
                                          <template v-slot:activator="{ props }">
                                            <v-chip 
                                              v-bind="props" 
                                              color="primary" 
                                              variant="flat" 
                                              elevation="2" 
                                              label 
                                              class="hoverableText"
                                            >
                                              <v-icon size="small">mdi-briefcase-account</v-icon>
                                            </v-chip>
                                          </template>
                                          <v-list density="compact" style="padding: 0px 5px; margin: 0; max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                                            <template 
                                              v-for="([CRMAgentID, CRMAgent]) in Object.entries(product.byCRMAgent).sort((CRMAgentA, CRMAgentB) => input.show == 'productAmount' ? (input.sort == 'DESC' ? CRMAgentB[1].productAmount - CRMAgentA[1].productAmount : CRMAgentA[1].productAmount - CRMAgentB[1].productAmount) : (input.sort == 'DESC' ? CRMAgentB[1].productSale - CRMAgentA[1].productSale : CRMAgentA[1].productSale - CRMAgentB[1].productSale))" 
                                              v-bind:key="CRMAgentID"
                                            >
                                              <v-list-item 
                                                @click.prevent="null"  
                                                class="hoverableText" 
                                                style="padding: 0; margin: 0; overflow-x: hidden;"
                                              >
                                                <v-list-item-title>
                                                  <div style="display: flex; align-items: center; min-width: 400px; gap: 10px;">
                                                    <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID)">
                                                      <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentColor || 'primary'" elevation="2" variant="flat" label>
                                                        <div style="display: flex; align-items: center;">
                                                          <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                                                          <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == CRMAgentID).CRMAgentName }}</p>
                                                        </div>
                                                      </v-chip>
                                                    </template>
                                                    <template v-else>
                                                      <v-chip color="primary" elevation="2" variant="flat" label>
                                                        <div style="display: flex; align-items: center;">
                                                          <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                                                          <p>No registrado</p>
                                                        </div>
                                                      </v-chip>
                                                    </template>
                                                    <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
                                                      <template v-if="input.show == 'productAmount'">
                                                        <v-tooltip 
                                                          :disabled="systemInformationData.tooltipDisabled" 
                                                          :text="`Unidad${CRMAgent.productAmount == 1 ? '': 'es'} vendida${CRMAgent.productAmount == 1 ? '': 's'}`" 
                                                          location="top"
                                                        >
                                                          <template v-slot:activator="{ props }">
                                                            <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                              <v-icon size="small" start>mdi-counter</v-icon>
                                                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.productAmount) }}</strong></p>
                                                            </v-chip>
                                                          </template>
                                                        </v-tooltip>
                                                        <v-tooltip location="top">
                                                          <template v-slot:activator="{ props }">
                                                            <v-chip 
                                                              v-bind="props" 
                                                              :color="(CRMAgent.offsetProductAmount == 0 || CRMAgent.productAmount == CRMAgent.offsetProductAmount) ? 'primary' : CRMAgent.productAmount > CRMAgent.offsetProductAmount ? 'success' : 'error'" 
                                                              variant="flat" 
                                                              elevation="2" 
                                                              label
                                                              class="hoverableText"
                                                            >
                                                              <v-icon size="small" start>
                                                                {{ (CRMAgent.offsetProductAmount == 0 || CRMAgent.productAmount == CRMAgent.offsetProductAmount) ? 'mdi-trending-neutral' : CRMAgent.productAmount > CRMAgent.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                              </v-icon>
                                                              <template v-if="CRMAgent.productAmount == 0 && CRMAgent.offsetProductAmount == 0">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMAgent.productAmount == 0 && CRMAgent.offsetProductAmount > 0">
                                                                <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMAgent.offsetProductAmount == 0 && CRMAgent.productAmount > 0">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMAgent.productAmount == CRMAgent.offsetProductAmount">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMAgent.productAmount > CRMAgent.offsetProductAmount">
                                                                <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productAmount - CRMAgent.offsetProductAmount) / CRMAgent.offsetProductAmount) * 100)) }} %</strong></p>
                                                              </template>
                                                              <template v-else>
                                                                <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productAmount - CRMAgent.offsetProductAmount) / CRMAgent.offsetProductAmount) * 100)) }} %</strong></p>
                                                              </template>
                                                            </v-chip>
                                                          </template>
                                                          <div>
                                                            <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.productAmount) }}</p>
                                                            <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMAgent.offsetProductAmount) }}</p>
                                                            <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ CRMAgent.productAmount > CRMAgent.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(CRMAgent.productAmount - CRMAgent.offsetProductAmount)) }}</p>
                                                          </div>
                                                        </v-tooltip>
                                                      </template>
                                                      <template v-else>
                                                        <v-tooltip 
                                                          :disabled="systemInformationData.tooltipDisabled" 
                                                          :text="`Monto de venta${CRMAgent.productSale == 1 ? '': 's'}`" 
                                                          location="top"
                                                        >
                                                          <template v-slot:activator="{ props }">
                                                            <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                              <v-icon size="small" start>mdi-cash</v-icon>
                                                              <p style="font-size: small;"><strong>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.productSale || 0) / 5) * 5) }}</strong></p>
                                                            </v-chip>
                                                          </template>
                                                        </v-tooltip>
                                                        <v-tooltip location="top">
                                                          <template v-slot:activator="{ props }">
                                                            <v-chip 
                                                              v-bind="props" 
                                                              :color="(CRMAgent.offsetProductSale == 0 || CRMAgent.productSale == CRMAgent.offsetProductSale) ? 'primary' : CRMAgent.productSale > CRMAgent.offsetProductSale ? 'success' : 'error'" 
                                                              variant="flat" 
                                                              elevation="2" 
                                                              label
                                                              class="hoverableText"
                                                            >
                                                              <v-icon size="small" start>
                                                                {{ (CRMAgent.offsetProductSale == 0 || CRMAgent.productSale == CRMAgent.offsetProductSale) ? 'mdi-trending-neutral' : CRMAgent.productSale > CRMAgent.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                              </v-icon>
                                                              <template v-if="CRMAgent.productSale == 0 && CRMAgent.offsetProductSale == 0">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMAgent.productSale == 0 && CRMAgent.offsetProductSale > 0">
                                                                <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMAgent.offsetProductSale == 0 && CRMAgent.productSale > 0">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMAgent.productSale == CRMAgent.offsetProductSale">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMAgent.productSale > CRMAgent.offsetProductSale">
                                                                <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productSale - CRMAgent.offsetProductSale) / CRMAgent.offsetProductSale) * 100)) }} %</strong></p>
                                                              </template>
                                                              <template v-else>
                                                                <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMAgent.productSale - CRMAgent.offsetProductSale) / CRMAgent.offsetProductSale) * 100)) }} %</strong></p>
                                                              </template>
                                                            </v-chip>
                                                          </template>
                                                          <div>
                                                            <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.productSale || 0) / 5) * 5) }}</p>
                                                            <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMAgent.offsetProductSale || 0) / 5) * 5) }}</p>
                                                            <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ CRMAgent.productSale > CRMAgent.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(CRMAgent.productSale - CRMAgent.offsetProductSale) || 0) / 5) * 5) }}</p>
                                                          </div>
                                                        </v-tooltip>
                                                      </template>
                                                    </div>
                                                  </div>
                                                </v-list-item-title>
                                              </v-list-item>
                                            </template>
                                          </v-list>
                                        </v-menu>
                                        <v-menu 
                                          :close-on-content-click="false" 
                                          scrim 
                                          @contextmenu.prevent="null"
                                          style="cursor: default; user-select: none;">
                                          <template v-slot:activator="{ props }">
                                            <v-chip 
                                              v-bind="props" 
                                              color="primary" 
                                              variant="flat" 
                                              elevation="2" 
                                              label 
                                              class="hoverableText"
                                            >
                                              <v-icon size="small">mdi-store</v-icon>
                                            </v-chip>
                                          </template>
                                          <v-list density="compact" style="padding: 0px 5px; margin: 0; max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                                            <template 
                                              v-for="([CRMLocalityID, CRMLocality]) in Object.entries(product.byCRMLocality).sort((CRMLocalityA, CRMLocalityB) => input.show == 'productAmount' ? (input.sort == 'DESC' ? CRMLocalityB[1].productAmount - CRMLocalityA[1].productAmount : CRMLocalityA[1].productAmount - CRMLocalityB[1].productAmount) : (input.sort == 'DESC' ? CRMLocalityB[1].productSale - CRMLocalityA[1].productSale : CRMLocalityA[1].productSale - CRMLocalityB[1].productSale))" 
                                              v-bind:key="CRMLocalityID"
                                            >
                                              <v-list-item 
                                                @click.prevent="null"  
                                                class="hoverableText" 
                                                style="padding: 0; margin: 0; overflow-x: hidden;"
                                              >
                                                <v-list-item-title>
                                                  <div style="display: flex; align-items: center; min-width: 400px; gap: 10px;">
                                                    <template v-if="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID)">
                                                      <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID).CRMLocalityColor || 'primary'" elevation="2" variant="flat" label>
                                                        <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == CRMLocalityID).CRMLocalityName }}</p>
                                                      </v-chip>
                                                    </template>
                                                    <template v-else>
                                                      <v-chip color="primary" elevation="2" variant="flat" label>
                                                        <p>No registrada</p>
                                                      </v-chip>
                                                    </template>
                                                    <div style="margin-left: auto; display: flex; align-items: center; gap: 5px;">
                                                      <template v-if="input.show == 'productAmount'">
                                                        <v-tooltip 
                                                          :disabled="systemInformationData.tooltipDisabled" 
                                                          :text="`Unidad${CRMLocality.productAmount == 1 ? '': 'es'} vendida${CRMLocality.productAmount == 1 ? '': 's'}`" 
                                                          location="top"
                                                        >
                                                          <template v-slot:activator="{ props }">
                                                            <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                              <v-icon size="small" start>mdi-counter</v-icon>
                                                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.productAmount) }}</strong></p>
                                                            </v-chip>
                                                          </template>
                                                        </v-tooltip>
                                                        <v-tooltip location="top">
                                                          <template v-slot:activator="{ props }">
                                                            <v-chip 
                                                              v-bind="props" 
                                                              :color="(CRMLocality.offsetProductAmount == 0 || CRMLocality.productAmount == CRMLocality.offsetProductAmount) ? 'primary' : CRMLocality.productAmount > CRMLocality.offsetProductAmount ? 'success' : 'error'" 
                                                              variant="flat" 
                                                              elevation="2" 
                                                              label
                                                              class="hoverableText"
                                                            >
                                                              <v-icon size="small" start>
                                                                {{ (CRMLocality.offsetProductAmount == 0 || CRMLocality.productAmount == CRMLocality.offsetProductAmount) ? 'mdi-trending-neutral' : CRMLocality.productAmount > CRMLocality.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                              </v-icon>
                                                              <template v-if="CRMLocality.productAmount == 0 && CRMLocality.offsetProductAmount == 0">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMLocality.productAmount == 0 && CRMLocality.offsetProductAmount > 0">
                                                                <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMLocality.offsetProductAmount == 0 && CRMLocality.productAmount > 0">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMLocality.productAmount == CRMLocality.offsetProductAmount">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMLocality.productAmount > CRMLocality.offsetProductAmount">
                                                                <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productAmount - CRMLocality.offsetProductAmount) / CRMLocality.offsetProductAmount) * 100)) }} %</strong></p>
                                                              </template>
                                                              <template v-else>
                                                                <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productAmount - CRMLocality.offsetProductAmount) / CRMLocality.offsetProductAmount) * 100)) }} %</strong></p>
                                                              </template>
                                                            </v-chip>
                                                          </template>
                                                          <div>
                                                            <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.productAmount) }}</p>
                                                            <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(CRMLocality.offsetProductAmount) }}</p>
                                                            <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ CRMLocality.productAmount > CRMLocality.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(CRMLocality.productAmount - CRMLocality.offsetProductAmount)) }}</p>
                                                          </div>
                                                        </v-tooltip>
                                                      </template>
                                                      <template v-else>
                                                        <v-tooltip 
                                                          :disabled="systemInformationData.tooltipDisabled" 
                                                          :text="`Monto de venta${CRMLocality.productSale == 1 ? '': 's'}`" 
                                                          location="top"
                                                        >
                                                          <template v-slot:activator="{ props }">
                                                            <v-chip v-bind="props" color="primary" elevation="2" variant="flat" label class="hoverableText">
                                                              <v-icon size="small" start>mdi-cash</v-icon>
                                                              <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.productSale || 0) / 5) * 5) }}</strong></p>
                                                            </v-chip>
                                                          </template>
                                                        </v-tooltip>
                                                        <v-tooltip location="top">
                                                          <template v-slot:activator="{ props }">
                                                            <v-chip 
                                                              v-bind="props" 
                                                              :color="(CRMLocality.offsetProductSale == 0 || CRMLocality.productSale == CRMLocality.offsetProductSale) ? 'primary' : CRMLocality.productSale > CRMLocality.offsetProductSale ? 'success' : 'error'" 
                                                              variant="flat" 
                                                              elevation="2" 
                                                              label
                                                              class="hoverableText"
                                                            >
                                                              <v-icon size="small" start>
                                                                {{ (CRMLocality.offsetProductSale == 0 || CRMLocality.productSale == CRMLocality.offsetProductSale) ? 'mdi-trending-neutral' : CRMLocality.productSale > CRMLocality.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                              </v-icon>
                                                              <template v-if="CRMLocality.productSale == 0 && CRMLocality.offsetProductSale == 0">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMLocality.productSale == 0 && CRMLocality.offsetProductSale > 0">
                                                                <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMLocality.offsetProductSale == 0 && CRMLocality.productSale > 0">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMLocality.productSale == CRMLocality.offsetProductSale">
                                                                <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                              </template>
                                                              <template v-else-if="CRMLocality.productSale > CRMLocality.offsetProductSale">
                                                                <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productSale - CRMLocality.offsetProductSale) / CRMLocality.offsetProductSale) * 100)) }} %</strong></p>
                                                              </template>
                                                              <template v-else>
                                                                <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((CRMLocality.productSale - CRMLocality.offsetProductSale) / CRMLocality.offsetProductSale) * 100)) }} %</strong></p>
                                                              </template>
                                                            </v-chip>
                                                          </template>
                                                          <div>
                                                            <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.productSale || 0) / 5) * 5) }}</p>
                                                            <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((CRMLocality.offsetProductSale || 0) / 5) * 5) }}</p>
                                                            <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ CRMLocality.productSale > CRMLocality.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(CRMLocality.productSale - CRMLocality.offsetProductSale) || 0) / 5) * 5) }}</p>
                                                          </div>
                                                        </v-tooltip>
                                                      </template>
                                                    </div>
                                                  </div>
                                                </v-list-item-title>
                                              </v-list-item>
                                            </template>
                                          </v-list>
                                        </v-menu>
                                        <template v-if="input.show == 'productAmount'">
                                          <v-tooltip location="top">
                                            <template v-slot:activator="{ props }">
                                              <v-chip 
                                                v-bind="props" 
                                                :color="(product.offsetProductAmount == 0 || product.productAmount == product.offsetProductAmount) ? 'primary' : product.productAmount > product.offsetProductAmount ? 'success' : 'error'" 
                                                variant="flat" 
                                                elevation="2" 
                                                label
                                                class="hoverableText"
                                              >
                                                <v-icon size="small" start>
                                                  {{ (product.offsetProductAmount == 0 || product.productAmount == product.offsetProductAmount) ? 'mdi-trending-neutral' : product.productAmount > product.offsetProductAmount ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                </v-icon>
                                                <template v-if="product.productAmount == 0 && product.offsetProductAmount == 0">
                                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                </template>
                                                <template v-else-if="product.productAmount == 0 && product.offsetProductAmount > 0">
                                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                </template>
                                                <template v-else-if="product.offsetProductAmount == 0 && product.productAmount > 0">
                                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                </template>
                                                <template v-else-if="product.productAmount == product.offsetProductAmount">
                                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                </template>
                                                <template v-else-if="product.productAmount > product.offsetProductAmount">
                                                  <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((product.productAmount - product.offsetProductAmount) / product.offsetProductAmount) * 100)) }} %</strong></p>
                                                </template>
                                                <template v-else>
                                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((product.productAmount - product.offsetProductAmount) / product.offsetProductAmount) * 100)) }} %</strong></p>
                                                </template>
                                              </v-chip>
                                            </template>
                                            <div>
                                              <p style="font-size: small;"><strong>Cantidad de unidades vendidas:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(product.productAmount) }}</p>
                                              <p style="font-size: small;"><strong>Cantidad de unidades vendidas de comparación:</strong> {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(product.offsetProductAmount) }}</p>
                                              <p style="font-size: small;"><strong>Diferencia de unidades vendidas:</strong> {{ product.productAmount > product.offsetProductAmount ? '+' : '-'}} {{ $displayFunctions.default.parseAmountToDisplayWithoutDecimals(Math.abs(product.productAmount - product.offsetProductAmount)) }}</p>
                                            </div>
                                          </v-tooltip>
                                        </template>
                                        <template v-else>
                                          <v-tooltip location="top">
                                            <template v-slot:activator="{ props }">
                                              <v-chip 
                                                v-bind="props" 
                                                :color="(product.offsetProductSale == 0 || product.productSale == product.offsetProductSale) ? 'primary' : product.productSale > product.offsetProductSale ? 'success' : 'error'" 
                                                variant="flat" 
                                                elevation="2" 
                                                label
                                                class="hoverableText"
                                              >
                                                <v-icon size="small" start>
                                                  {{ (product.offsetProductSale == 0 || product.productSale == product.offsetProductSale) ? 'mdi-trending-neutral' : product.productSale > product.offsetProductSale ? 'mdi-trending-up' : 'mdi-trending-down' }}
                                                </v-icon>
                                                <template v-if="product.productSale == 0 && product.offsetProductSale == 0">
                                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                </template>
                                                <template v-else-if="product.productSale == 0 && product.offsetProductSale > 0">
                                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(100) }} %</strong></p>
                                                </template>
                                                <template v-else-if="product.offsetProductSale == 0 && product.productSale > 0">
                                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                </template>
                                                <template v-else-if="product.productSale == product.offsetProductSale">
                                                  <p style="font-size: small;"><strong>{{ $displayFunctions.default.parseAmountToDisplay(0) }} %</strong></p>
                                                </template>
                                                <template v-else-if="product.productSale > product.offsetProductSale">
                                                  <p style="font-size: small;"><strong>+{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((product.productSale - product.offsetProductSale) / product.offsetProductSale) * 100)) }} %</strong></p>
                                                </template>
                                                <template v-else>
                                                  <p style="font-size: small;"><strong>-{{ $displayFunctions.default.parseAmountToDisplay(Math.abs(((product.productSale - product.offsetProductSale) / product.offsetProductSale) * 100)) }} %</strong></p>
                                                </template>
                                              </v-chip>
                                            </template>
                                            <div>
                                              <p style="font-size: small;"><strong>Monto de venta:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((product.productSale || 0) / 5) * 5) }}</p>
                                              <p style="font-size: small;"><strong>Monto de venta de comparación:</strong> ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((product.offsetProductSale || 0) / 5) * 5) }}</p>
                                              <p style="font-size: small;"><strong>Diferencia de venta:</strong> {{ product.productSale > product.offsetProductSale ? '+' : '-'}} ₡{{ $displayFunctions.default.parseAmountToDisplay(Math.round((Math.abs(product.productSale - product.offsetProductSale) || 0) / 5) * 5) }}</p>
                                            </div>
                                          </v-tooltip>
                                        </template>
                                      </div>
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-expansion-panel-text>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </div>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </template>
      <template v-else-if="navigation.noData">
        <div 
          @click="setDefaultValues()"
          style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding: 15px;"
        >
          <div class="hoverableText">
            <v-icon color="indigo" size="large" style="margin-bottom: 10px;">mdi-information</v-icon>
            <p style="color: #9e9e9e;">No se encontraron resultados para la tendencia de venta con los filtros seleccionados</p>
            <p style="color: #9e9e9e;">Haz click <span style="color: #3F51B5; text-decoration: underline;">aquí</span> para limpiar los filtros de búsqueda</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding: 15px;">
          <v-icon color="indigo" size="large" style="margin-bottom: 10px;">mdi-information</v-icon>
          <div style="display: flex; align-items: center; gap: 10px;">
            <p style="color: #9e9e9e;">Selecciona uno o más criterios de búsqueda y presiona</p>
            <v-btn color="indigo" readonly>
              <v-icon size="large" style="margin-right: 10px;">mdi-magnify</v-icon>
              <h3>BUSCAR</h3>
            </v-btn>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<style scoped>
  .mainContainer {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    overflow: hidden;
    margin-top: 0;
    padding-top: 0;
  }
  .navigationContainer {
    display: flex;
    flex-direction: column;
    width: 25%;
  }
  .navigationSearchContainer {
    flex: 1;
    width: 100%;
    padding: 15px;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .contentContainer {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .cardContainer {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
  }
  .twoColumnsContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 15px;
    gap: 15px;
    text-align: center;
    align-items: center;
  }

  @media (max-width: 1200px) {
    .hideSearchContainer {
      display: none;
    }
    .mainContainer {
      flex-direction: column;
      height: auto;
      overflow-y: auto;
    }
    .navigationContainer {
      width: 100%;
    }
    .contentContainer {
      min-height: 900px;
      max-height: 900px;
    }
    .cardContainer {
      grid-template-columns: repeat(1, 1fr);
    }
    .twoColumnsContainer {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import { VDateInput } from 'vuetify/labs/VDateInput';
  import LZString from 'lz-string';
  import VueApexCharts from 'vue3-apexcharts';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';
  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    components:
    {
      VDateInput,
      apexchart: VueApexCharts,
      AppLoaderScreen
    },
    data: () => 
    ({
      input: 
      {
        CRMWhatsappInvoiceCreationDatetime: [],
        CRMLocalityIDSearch: null,
        CRMLocalityID: [],
        allCRMLocalityIDSelected: false,
        CRMLocalityMapDivisionIDSearch: null,
        CRMLocalityMapDivisionID: [],
        allCRMLocalityMapDivisionIDSelected: false,
        CRMWhatsappInvoiceCreationCRMAgentIDSearch: null,
        CRMWhatsappInvoiceCreationCRMAgentID: [],
        allCRMWhatsappInvoiceCreationCRMAgentIDSelected: false,
        CRMWhatsappInvoiceShippingMethodSearch: null,
        CRMWhatsappInvoiceShippingMethod: [],
        allCRMWhatsappInvoiceShippingMethodSelected: false,
        productIDSearch: null,
        productID: null,
        productCategoryIDSearch: null,
        productCategoryID: [],
        allProductCategoryIDSelected: false,
        productBrandIDSearch: null,
        productBrandID: [],
        allProductBrandIDSelected: false,
        productModelIDSearch: null,
        productModelID: [],
        allProductModelIDSelected: false,
        productFlavorIDSearch: null,
        productFlavorID: [],
        allProductFlavorIDSelected: false,
        productNicotineLevelIDSearch: null,
        productNicotineLevelID: [],
        allProductNicotineLevelIDSelected: false,
        productSizeIDSearch: null,
        productSizeID: [],
        allProductSizeIDSelected: false,
        productProviderIDSearch: null,
        productProviderID: [],
        allProductProviderIDSelected: false,
        productTagIDSearch: null,
        productTagID: [],
        allProductTagIDSelected: false,
        show: 'productAmount',
        sort: 'DESC'
      },
      display: 
      {
        CRMLocalityMapDivision: [],
        CRMWhatsappInvoiceShippingMethod: ['Envío mediante sistema', 'Envío mediante correo', 'Envío mediante encomienda', 'Envío mediante Uber Flash', 'Retiro en localidad'],
        product: [],
        productCategory: [],
        productBrand: [],
        productModel: [],
        productFlavor: [],
        productNicotineLevel: [],
        productSize: [],
        productProvider: [],
        productTag: [],
        CRMProductSale: [],
        startDate: null,
        endDate: null,
        offsetStartDate: null,
        offsetEndDate: null
      },
      navigation: 
      {
        searchVisible: true,
        noData: false
      },
      loader: 
      {
        getSystemInformationData: false,
        selectCRMProductSaleFromCRMProductSaleView: false,
        selectProductSearchParameters: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMLocalities: [],
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed:
    {
      computed_CRMLocalityMapDivision(){
        if (this.input.CRMLocalityID.length == 0) return this.display.CRMLocalityMapDivision;
        return this.display.CRMLocalityMapDivision.slice().filter(CRMLocalityMapDivision => this.input.CRMLocalityID.includes(CRMLocalityMapDivision.CRMLocalityID));
      },
      computed_sortedProductCategory(){
        if (this.input.show == 'productAmount'){
          if (this.input.sort == 'DESC') return this.display.CRMProductSale.slice().sort((productCategoryA, productCategoryB) => productCategoryB.productAmount - productCategoryA.productAmount);
          return this.display.CRMProductSale.slice().sort((productCategoryA, productCategoryB) => productCategoryA.productAmount - productCategoryB.productAmount);
        } else {
          if (this.input.sort == 'DESC') return this.display.CRMProductSale.slice().sort((productCategoryA, productCategoryB) => productCategoryB.productSale - productCategoryA.productSale);
          return this.display.CRMProductSale.slice().sort((productCategoryA, productCategoryB) => productCategoryA.productSale - productCategoryB.productSale);
        }
      },
      computed_sortedProductBrand(){
        if (this.input.show == 'productAmount'){
          if (this.input.sort == 'DESC') return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).sort((productBrandA, productBrandB) => productBrandB.productAmount - productBrandA.productAmount);
          return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).sort((productBrandA, productBrandB) => productBrandA.productAmount - productBrandB.productAmount);
        } else {
          if (this.input.sort == 'DESC') return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).sort((productBrandA, productBrandB) => productBrandB.productSale - productBrandA.productSale);
          return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).sort((productBrandA, productBrandB) => productBrandA.productSale - productBrandB.productSale);
        }
      },
      computed_sortedProductModel(){
        if (this.input.show == 'productAmount'){
          if (this.input.sort == 'DESC') return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).flatMap(productBrand => productBrand.productModels).sort((productModelA, productModelB) => productModelB.productAmount - productModelA.productAmount);
          return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).flatMap(productBrand => productBrand.productModels).sort((productModelA, productModelB) => productModelA.productAmount - productModelB.productAmount);
        } else {
          if (this.input.sort == 'DESC') return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).flatMap(productBrand => productBrand.productModels).sort((productModelA, productModelB) => productModelB.productSale - productModelA.productSale);
          return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).flatMap(productBrand => productBrand.productModels).sort((productModelA, productModelB) => productModelA.productSale - productModelB.productSale);
        }
      },
      computed_sortedProduct(){
        if (this.input.show == 'productAmount') return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).flatMap(productBrand => productBrand.productModels).flatMap(productModel => productModel.products).sort((productA, productB) => productB.productAmount - productA.productAmount);
        return this.display.CRMProductSale.slice().flatMap(productCategory => productCategory.productBrands).flatMap(productBrand => productBrand.productModels).flatMap(productModel => productModel.products).sort((productA, productB) => productA.productSale - productB.productSale);
      }
    },
    methods:
    {
      async selectCRMProductSaleFromCRMProductSaleView(){
        this.input.show = 'productAmount';
        this.input.sort = 'DESC';
        this.display.CRMProductSale.length = 0;
        this.display.startDate = null;
        this.display.endDate = null;
        this.display.offsetStartDate = null;
        this.display.offsetEndDate = null;
        this.navigation.noData = false;
        if (this.input.CRMWhatsappInvoiceCreationDatetime.length == 0) this.input.CRMWhatsappInvoiceCreationDatetime = Array.from({length: new Date().getDate()}, (_, i) => new Date(new Date().getFullYear(), new Date().getMonth(), i + 1));
        this.loader.selectCRMProductSaleFromCRMProductSaleView = true;
        const selectCRMProductSaleFromCRMProductSaleViewRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'startDate': this.input.CRMWhatsappInvoiceCreationDatetime.length > 0 ? this.input.CRMWhatsappInvoiceCreationDatetime[0] : null,
          'endDate': this.input.CRMWhatsappInvoiceCreationDatetime.length > 0 ? this.input.CRMWhatsappInvoiceCreationDatetime[this.input.CRMWhatsappInvoiceCreationDatetime.length - 1] : null,
          'CRMLocalityID': this.input.CRMLocalityID,
          'CRMLocalityMapDivisionID': this.input.CRMLocalityMapDivisionID,
          'CRMWhatsappInvoiceCreationCRMAgentID': this.input.CRMWhatsappInvoiceCreationCRMAgentID,
          'CRMWhatsappInvoiceShippingMethod': this.input.CRMWhatsappInvoiceShippingMethod,
          'productID': this.input.productID,
          'productCategoryID': this.input.productCategoryID,
          'productBrandID': this.input.productBrandID,
          'productModelID': this.input.productModelID,
          'productFlavorID': this.input.productFlavorID,
          'productNicotineLevelID': this.input.productNicotineLevelID,
          'productSizeID': this.input.productSizeID,
          'productProviderID': this.input.productProviderID,
          'productTagID': this.input.productTagID
        };
        const selectCRMProductSaleFromCRMProductSaleViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMProductSale/functions/selectCRMProductSaleFromCRMProductSaleView', selectCRMProductSaleFromCRMProductSaleViewRequestQuery);
        if (selectCRMProductSaleFromCRMProductSaleViewResult.success){
          this.display.CRMProductSale = selectCRMProductSaleFromCRMProductSaleViewResult.result.CRMProductSale;
          this.display.startDate = selectCRMProductSaleFromCRMProductSaleViewResult.result.startDate;
          this.display.endDate = selectCRMProductSaleFromCRMProductSaleViewResult.result.endDate;
          this.display.offsetStartDate = selectCRMProductSaleFromCRMProductSaleViewResult.result.offsetStartDate;
          this.display.offsetEndDate = selectCRMProductSaleFromCRMProductSaleViewResult.result.offsetEndDate;
          this.navigation.noData = this.display.CRMProductSale.length == 0;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMProductSaleFromCRMProductSaleView_error', 'error', 'Ha ocurrido un error inesperado al consultar la información de la tendencia de venta, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.selectCRMProductSaleFromCRMProductSaleView = false;
      },
      async selectProductSearchParameters(){
        this.loader.selectProductSearchParameters = true;
        const selectProductSearchParametersRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectProductSearchParametersResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/product/functions/selectProductSearchParameters', selectProductSearchParametersRequestQuery);
        if (selectProductSearchParametersResult.success) {
          this.display.product = selectProductSearchParametersResult.result.products.map(product => ({
            'productID': product.productID,
            'productName': product.productName,
            'productAutocomplete': `${product.productID} - ${product.productName}`
          }));
          this.display.productCategory = selectProductSearchParametersResult.result.productCategories;
          this.display.productBrand = selectProductSearchParametersResult.result.productBrands;
          this.display.productModel = selectProductSearchParametersResult.result.productModels;
          this.display.productFlavor = selectProductSearchParametersResult.result.productFlavors;
          this.display.productNicotineLevel = selectProductSearchParametersResult.result.productNicotineLevels;
          this.display.productSize = selectProductSearchParametersResult.result.productSizes;
          this.display.productProvider = selectProductSearchParametersResult.result.productProviders;
          this.display.productTag = selectProductSearchParametersResult.result.productTags;
          this.loader.selectProductSearchParameters = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectProductSearchParameters_error', 'error', 'Ha ocurrido un error inesperado al consultar los parámetros de búsqueda de productos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      scanProduct(){
        const scannedProduct = this.display.product.find(product => product.productID == this.input.productIDSearch);
        if (scannedProduct){
          this.input.productID = scannedProduct.productID;
          this.input.productIDSearch = scannedProduct.productName;
          this.selectCRMProductSaleFromCRMProductSaleView();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('scanProduct_error', 'error', 'No se ha encontrado ningún producto con el código de barras escaneado', null, false);
        }
      },
      getProductCategoryPercentage(productCategory, round) {
        if (this.display.CRMProductSale.length == 0) return 0;
        const totalAmount = this.display.CRMProductSale.reduce((totalAmount, productCategory) => totalAmount + (this.input.show == 'productAmount' ? productCategory.productAmount : productCategory.productSale), 0);
        return round ? Math.round(((this.input.show == 'productAmount' ? productCategory.productAmount : productCategory.productSale) / totalAmount) * 100) : (((this.input.show == 'productAmount' ? productCategory.productAmount : productCategory.productSale) / totalAmount) * 100).toFixed(2);
      },
      getProductBrandPercentage(productCategory, productBrandID, round) {
        if (this.display.CRMProductSale.length == 0) return 0;
        const productBrand = productCategory.productBrands.find(productBrand => productBrand.productBrandID == productBrandID);
        const totalAmount = productCategory.productBrands.reduce((totalAmount, productBrand) => totalAmount + (this.input.show == 'productAmount' ? productBrand.productAmount : productBrand.productSale), 0);
        return round ? Math.round(((this.input.show == 'productAmount' ? productBrand.productAmount : productBrand.productSale) / totalAmount) * 100) : (((this.input.show == 'productAmount' ? productBrand.productAmount : productBrand.productSale) / totalAmount) * 100).toFixed(2);
      },
      getProductModelPercentage(productCategory, productBrandID, productModelID, round) {
        if (this.display.CRMProductSale.length == 0) return 0;
        const productBrand = productCategory.productBrands.find(productBrand => productBrand.productBrandID == productBrandID);
        const productModel = productBrand.productModels.find(productModel => productModel.productModelID == productModelID);
        const totalAmount = productBrand.productModels.reduce((totalAmount, productModel) => totalAmount + (this.input.show == 'productAmount' ? productModel.productAmount : productModel.productSale), 0);
        return round ? Math.round(((this.input.show == 'productAmount' ? productModel.productAmount : productModel.productSale) / totalAmount) * 100) : (((this.input.show == 'productAmount' ? productModel.productAmount : productModel.productSale) / totalAmount) * 100).toFixed(2);
      },
      updateURLSearchQuery(){
        if (this.input.CRMWhatsappInvoiceCreationDatetime.length == 0) this.input.CRMWhatsappInvoiceCreationDatetime = Array.from({length: new Date().getDate()}, (_, i) => new Date(new Date().getFullYear(), new Date().getMonth(), i + 1).toLocaleDateString('sv-SE'));
        let searchQuery = 
        {
          '1': this.input.CRMWhatsappInvoiceCreationDatetime[0],
          '2': this.input.CRMWhatsappInvoiceCreationDatetime[this.input.CRMWhatsappInvoiceCreationDatetime.length - 1],
          '3': this.input.CRMLocalityID,
          '4': this.input.CRMLocalityMapDivisionID,
          '5': this.input.CRMWhatsappInvoiceCreationCRMAgentID,
          '6': this.input.CRMWhatsappInvoiceShippingMethod,
          '7': this.input.productID,
          '8': this.input.productCategoryID,
          '9': this.input.productBrandID,
          '10': this.input.productModelID,
          '11': this.input.productFlavorID,
          '12': this.input.productNicotineLevelID,
          '13': this.input.productSizeID,
          '14': this.input.productProviderID,
          '15': this.input.productTagID
        };
        searchQuery = Object.fromEntries(Object.entries(searchQuery).filter(([ , v]) => v != null && v != undefined));
        const searchQueryCompressed = LZString.compressToEncodedURIComponent(JSON.stringify(searchQuery));
        this.$router.replace({query: {searchQuery: searchQueryCompressed}});
      },
      async decodeURLSearchQuery(){
        let searchQuery = this.$route.query.searchQuery;
        if (searchQuery){
          searchQuery = JSON.parse(LZString.decompressFromEncodedURIComponent(searchQuery));
          if (searchQuery['1'] && !isNaN(new Date(searchQuery['1']).getTime()) && searchQuery['2'] && !isNaN(new Date(searchQuery['2']).getTime())) this.input.CRMWhatsappInvoiceCreationDatetime = (() => { const s = new Date(searchQuery['1']); const e = new Date(searchQuery['2']); s.setHours(0,0,0,0); e.setHours(0,0,0,0); const d = Math.floor((e - s) / 86400000) + 1; return Array.from({length: d}, (_, i) => new Date(s.getTime() + i * 86400000)); })();
          else this.input.CRMWhatsappInvoiceCreationDatetime = Array.from({length: new Date().getDate()}, (_, i) => new Date(new Date().getFullYear(), new Date().getMonth(), i + 1));
          this.input.CRMLocalityID = searchQuery['3'] || [];
          this.input.allCRMLocalityIDSelected = searchQuery['3'].length == this.systemInformationData.CRMLocalities.filter(CRMLocality => CRMLocality.CRMLocalityID != null).length;
          this.input.CRMLocalityMapDivisionID = searchQuery['4'] || [];
          this.input.allCRMLocalityMapDivisionIDSelected = searchQuery['4'].length == this.systemInformationData.CRMLocalities.flatMap(CRMLocality => CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions).filter(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID != null).length;
          this.input.CRMWhatsappInvoiceCreationCRMAgentID = searchQuery['5'] || [];
          this.input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected = searchQuery['5'].length == this.systemInformationData.CRMAgents.filter(CRMAgent => CRMAgent.CRMAgentID != null).length;
          this.input.CRMWhatsappInvoiceShippingMethod = searchQuery['6'] || [];
          this.input.allCRMWhatsappInvoiceShippingMethodSelected = searchQuery['6'].length == this.display.CRMWhatsappInvoiceShippingMethod.length;
          this.input.productID = searchQuery['7'];
          this.input.productCategoryID = searchQuery['8'] || [];
          this.input.allProductCategoryIDSelected = searchQuery['8'].length == this.display.productCategory.length;
          this.input.productBrandID = searchQuery['9'] || [];
          this.input.allProductBrandIDSelected = searchQuery['9'].length == this.display.productBrand.length;
          this.input.productModelID = searchQuery['10'] || [];
          this.input.allProductModelIDSelected = searchQuery['10'].length == this.display.productModel.length;
          this.input.productFlavorID = searchQuery['11'] || [];
          this.input.allProductFlavorIDSelected = searchQuery['11'].length == this.display.productFlavor.length;
          this.input.productNicotineLevelID = searchQuery['12'] || [];
          this.input.allProductNicotineLevelIDSelected = searchQuery['12'].length == this.display.productNicotineLevel.length;
          this.input.productSizeID = searchQuery['13'] || [];
          this.input.allProductSizeIDSelected = searchQuery['13'].length == this.display.productSize.length;
          this.input.productProviderID = searchQuery['14'] || [];
          this.input.allProductProviderIDSelected = searchQuery['14'].length == this.display.productProvider.length;
          this.input.productTagID = searchQuery['15'] || [];
          this.input.allProductTagIDSelected = searchQuery['15'].length == this.display.productTag.length;
        }
      },
      setDefaultValues(){
        this.input.CRMWhatsappInvoiceCreationDatetime = Array.from({length: new Date().getDate()}, (_, i) => new Date(new Date().getFullYear(), new Date().getMonth(), i + 1));
        this.input.CRMLocalityID.length = 0;
        this.input.allCRMLocalityIDSelected = false;
        this.input.CRMLocalityMapDivisionIDSearch = null;
        this.input.CRMLocalityMapDivisionID.length = 0;
        this.input.allCRMLocalityMapDivisionIDSelected = false;
        this.input.CRMWhatsappInvoiceCreationCRMAgentIDSearch = null;
        this.input.CRMWhatsappInvoiceCreationCRMAgentID.length = 0;
        this.input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected = false;
        this.input.CRMWhatsappInvoiceShippingMethodSearch = null;
        this.input.CRMWhatsappInvoiceShippingMethod.length = 0;
        this.input.allCRMWhatsappInvoiceShippingMethodSelected = false;
        this.input.productIDSearch = null;
        this.input.productID = null;
        this.input.productCategoryIDSearch = null;
        this.input.productCategoryID.length = 0;
        this.input.allProductCategoryIDSelected = false;
        this.input.productBrandIDSearch = null;
        this.input.productBrandID.length = 0;
        this.input.allProductBrandIDSelected = false;
        this.input.productModelIDSearch = null;
        this.input.productModelID.length = 0;
        this.input.allProductModelIDSelected = false;
        this.input.productFlavorIDSearch = null;
        this.input.productFlavorID.length = 0;
        this.input.allProductFlavorIDSelected = false;
        this.input.productNicotineLevelIDSearch = null;
        this.input.productNicotineLevelID.length = 0;
        this.input.allProductNicotineLevelIDSelected = false;
        this.input.productSizeIDSearch = null;
        this.input.productSizeID.length = 0;
        this.input.allProductSizeIDSelected = false;
        this.input.productProviderIDSearch = null;
        this.input.productProviderID.length = 0;
        this.input.allProductProviderIDSelected = false;
        this.input.productTagIDSearch = null;
        this.input.productTagID.length = 0;
        this.input.allProductTagIDSelected = false;
        this.input.show = 'productAmount';
        this.input.sort = 'DESC';
        this.display.CRMProductSale.length = 0;
        this.display.startDate = null;
        this.display.endDate = null;
        this.display.offsetStartDate = null;
        this.display.offsetEndDate = null;
        this.navigation.noData = false;
        this.updateURLSearchQuery();
      },
      async getSystemInformationData(){
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            if (this.systemInformationData.CRMAgent?.CRMAgentPermissions.find((CRMAgentPermission) => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/CRMLocalityID')){
              let CRMLocalityIDPermissions = JSON.parse(this.systemInformationData.CRMAgent?.CRMAgentPermissions.find((CRMAgentPermission) => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/CRMLocalityID').CRMAgentPermissionValue);
              if (CRMLocalityIDPermissions.length > 0) this.systemInformationData.CRMLocalities = this.systemInformationData.CRMLocalities.filter(
                CRMLocality => CRMLocality.CRMLocalityID != null && CRMLocality.CRMLocalityID != undefined && CRMLocalityIDPermissions.includes(CRMLocality.CRMLocalityID)
              );
            }
            this.display.CRMLocalityMapDivision = this.systemInformationData.CRMLocalities.flatMap(CRMLocality => 
              CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => ({
                'CRMLocalityID': CRMLocality.CRMLocalityID,
                'CRMLocalityMapDivisionID': CRMLocalityMapDivision.CRMLocalityMapDivisionID,
                'CRMLocalityMapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName,
              }))
            );
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
            this.loader.getSystemInformationData = false;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },
    async mounted(){
      await this.getSystemInformationData();
      await this.selectProductSearchParameters();
      this.decodeURLSearchQuery();
    },
    beforeUnmount(){
      if (this.systemInformationData.updateSubscription) {
        systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
      }
    }
  }
</script>